(() => {
  if (window.__zepRestockRequestV1) return;
  window.__zepRestockRequestV1 = true;

  const styleId = 'zep-restock-request-style';
  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };
  const addHidden = (form, name, value) => {
    const input = create('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };
  const ensureStyle = () => {
    if (document.getElementById(styleId)) return;
    const style = create('style');
    style.id = styleId;
    style.textContent = '.zep-restock-request{margin:12px 0 0;padding:12px;border:1px solid #d9def5;border-radius:10px;background:#f5f6ff}.zep-restock-request__title{display:block;margin:0 0 7px;font-size:13px;line-height:1.35;font-weight:800;color:#17191c}.zep-restock-request__row{display:flex;gap:8px}.zep-restock-request__email{min-width:0;flex:1;min-height:48px;padding:10px 12px;border:1px solid #aeb6c2;border-radius:8px;background:#fff;color:#17191c;font-size:14px}.zep-restock-request__email:focus{outline:3px solid rgba(16,16,75,.2);outline-offset:1px;border-color:#10104b}.zep-restock-request__button{min-height:48px;padding:10px 15px;border:0;border-radius:8px;background:#10104b;color:#fff;font-size:13px;font-weight:800;cursor:pointer}.zep-restock-request__button:hover{background:#202066}.zep-restock-request__privacy{margin:7px 0 0;font-size:11px;line-height:1.4;color:#626872}.zep-restock-request__success{margin:0;padding:11px;border-radius:8px;background:#eaf6ee;color:#176b32;font-size:13px;line-height:1.45;font-weight:750}@media(max-width:600px){.zep-restock-request__row{flex-direction:column}.zep-restock-request__button{width:100%}}';
    document.head.appendChild(style);
  };
  const mount = (card, index) => {
    if (card.querySelector('.zep-restock-request')) return;
    const productForm = card.closest('form[data-type="add-to-cart-form"]');
    if (!productForm) return;

    ensureStyle();
    const productId = document.querySelector('[data-product-id]')?.dataset.productId || String(index);
    const title = document.querySelector('h1')?.textContent?.replace(/\s+/g, ' ').trim() || document.title;
    const variantId = new URLSearchParams(location.search).get('variant') || '';
    const formId = `zep-restock-form-${productId}`;
    let requestForm = document.getElementById(formId);

    if (!requestForm) {
      requestForm = create('form');
      requestForm.id = formId;
      requestForm.method = 'post';
      requestForm.action = `/contact#${formId}`;
      requestForm.acceptCharset = 'UTF-8';
      requestForm.hidden = true;
      addHidden(requestForm, 'form_type', 'contact');
      addHidden(requestForm, 'utf8', '✓');
      addHidden(requestForm, 'contact[Subiect]', 'Cerere notificare revenire in stoc');
      addHidden(requestForm, 'contact[Produs]', title);
      addHidden(requestForm, 'contact[ID produs]', productId);
      addHidden(requestForm, 'contact[ID varianta]', variantId);
      addHidden(requestForm, 'contact[URL produs]', location.href);
      addHidden(requestForm, 'contact[Mesaj]', 'Doresc sa fiu notificat prin email cand acest produs revine in stoc.');
      const returnUrl = `${location.pathname}${location.search}${location.search ? '&' : '?'}zep_restock_sent=1#${formId}`;
      addHidden(requestForm, 'return_to', returnUrl);
      productForm.insertAdjacentElement('afterend', requestForm);
    }

    const panel = create('div', 'zep-restock-request');
    const sent = new URLSearchParams(location.search).get('zep_restock_sent') === '1' && location.hash === `#${formId}`;
    if (sent) {
      panel.appendChild(create('p', 'zep-restock-request__success', 'Cererea a fost inregistrata. Iti trimitem un email cand produsul revine in stoc.'));
    } else {
      const label = create('label', 'zep-restock-request__title', 'Vrei sa te anuntam cand revine in stoc?');
      const emailId = `${formId}-email`;
      label.htmlFor = emailId;
      const row = create('div', 'zep-restock-request__row');
      const email = create('input', 'zep-restock-request__email');
      email.id = emailId;
      email.type = 'email';
      email.name = 'contact[email]';
      email.placeholder = 'Adresa ta de email';
      email.autocomplete = 'email';
      email.inputMode = 'email';
      email.required = true;
      email.setAttribute('form', formId);
      email.setAttribute('aria-label', 'Adresa de email pentru notificarea de stoc');
      const button = create('button', 'zep-restock-request__button', 'Anunta-ma cand revine');
      button.type = 'submit';
      button.setAttribute('form', formId);
      row.append(email, button);
      const privacy = create('p', 'zep-restock-request__privacy', 'Folosim adresa doar pentru aceasta alerta. Nu te abonam la newsletter.');
      panel.append(label, row, privacy);
    }

    const actions = card.querySelector('.zep-soldout-rescue__actions');
    actions ? actions.insertAdjacentElement('beforebegin', panel) : card.appendChild(panel);
  };
  const run = () => {
    document.querySelectorAll('.zep-soldout-rescue').forEach(mount);
  };

  window.ZepPdpLivePipeline?.register(() => {
    run();
    return true;
  });
  document.addEventListener('contentUpdated', run);
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  run();
})();


(() => {
  'use strict';

  if (window.ZepShippingEstimator) {
    window.ZepShippingEstimator.initAll();
    return;
  }

  const RATE_RULES = Object.freeze([
    { min: 0, max: 5000, rate: 29.99 },
    { min: 5001, max: 10000, rate: 34.99 },
    { min: 10001, max: 15000, rate: 39.99 },
    { min: 15001, max: 20000, rate: 43.99 },
    { min: 20001, max: 25000, rate: 49.99 },
    { min: 25001, max: 30000, rate: 54.99 },
    { min: 30001, max: 35000, rate: 64.99 },
    { min: 35001, max: 40000, rate: 74.99 },
    { min: 40001, max: 45000, rate: 89.99 },
    { min: 45001, max: 50000, rate: 94.99 },
    { min: 50001, max: 60000, rate: 114.99 },
    { min: 60001, max: 80000, rate: 124 },
    { min: 80001, max: 110000, rate: 141 },
    { min: 110001, max: 150000, rate: 171 },
    { min: 150001, max: 180000, rate: 199 },
    { min: 180001, max: 250000, rate: 270 },
    { min: 250001, max: 499999, rate: 300 },
    { min: 500000, max: 999000, rate: 1000 }
  ]);

  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  const setHidden = (element, hidden) => {
    if (element && element.hidden !== hidden) element.hidden = hidden;
  };

  const addBusinessDays = (days) => {
    const date = new Date();
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
    }
    return date;
  };

  const formatDeliveryPart = (date) => {
    const parts = new Intl.DateTimeFormat('ro-RO', {
      day: 'numeric',
      month: 'short'
    }).formatToParts(date);
    return {
      day: parts.find((part) => part.type === 'day')?.value || '',
      month: parts.find((part) => part.type === 'month')?.value || ''
    };
  };

  const deliveryWindow = () => {
    const start = formatDeliveryPart(addBusinessDays(1));
    const end = formatDeliveryPart(addBusinessDays(3));
    return start.month === end.month
      ? start.day + '–' + end.day + ' ' + end.month
      : start.day + ' ' + start.month + '–' + end.day + ' ' + end.month;
  };

  const installPdpPresentationStyles = () => {
    if (document.getElementById('zep-calendar-delivery-style')) return;
    const style = document.createElement('style');
    style.id = 'zep-calendar-delivery-style';
    style.textContent = '.zep-shipping-estimator__main.zep-calendar-delivery{font-size:0!important}.zep-shipping-estimator__main.zep-calendar-delivery::before{content:attr(data-zep-calendar-label);font-size:14px;line-height:1.4}';
    document.head.appendChild(style);
  };

  const updatePdpAvailability = (element) => {
    const form = element.closest('form[action*="/cart/add"]');
    const button = form?.querySelector('.js_add_to_cart_button');
    const unavailable = Boolean(button && (
      button.disabled || button.classList.contains('d-none-important')
    ));
    setHidden(element, unavailable);
    const ariaHidden = unavailable ? 'true' : 'false';
    if (element.getAttribute('aria-hidden') !== ariaHidden) {
      element.setAttribute('aria-hidden', ariaHidden);
    }
  };

  const applyPdpPresentation = (main, label) => {
    setText(main, label);
    if (main.dataset.zepCalendarLabel !== label) main.dataset.zepCalendarLabel = label;
    if (main.getAttribute('aria-label') !== label) main.setAttribute('aria-label', label);
    main.classList.add('zep-calendar-delivery');
  };

  const clearPdpPresentation = (main) => {
    main.classList.remove('zep-calendar-delivery');
    main.removeAttribute('data-zep-calendar-label');
    main.removeAttribute('aria-label');
  };

  const formatRate = (rate) => new Intl.NumberFormat('ro-RO', {
    minimumFractionDigits: Number.isInteger(rate) ? 0 : 2,
    maximumFractionDigits: 2
  }).format(rate);

  const estimate = (grams) => {
    const value = Number(grams);
    if (!Number.isFinite(value) || value < 0) return null;
    const rule = RATE_RULES.find((item) => value >= item.min && value <= item.max);
    return rule ? rule.rate : null;
  };

  const getPdpState = (element) => {
    let variants = [];
    try {
      variants = JSON.parse(element.dataset.variants || '[]');
    } catch (_error) {
      return { unknown: true, grams: 0 };
    }

    const form = element.closest('form[data-type="add-to-cart-form"]') || element.closest('form');
    const variantInput = form && form.querySelector('[name="id"]');
    const quantityInput = form && form.querySelector('[name="quantity"]');
    const variantId = String((variantInput && variantInput.value) || element.dataset.selectedVariant || '');
    const variant = variants.find((item) => String(item.id) === variantId);
    const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

    if (!variant) {
      return { unknown: true, grams: 0 };
    }

    return {
      unknown: false,
      grams: Number(variant.weight || 0) * quantity,
      subtotal: Number(variant.price || 0) * quantity
    };
  };

  const render = (element) => {
    if (!element || !element.isConnected) return;

    const context = element.dataset.context;
    if (context === 'pdp') updatePdpAvailability(element);

    const state = context === 'pdp'
      ? getPdpState(element)
      : {
          unknown: false,
          grams: Number(element.dataset.weight || 0),
          subtotal: Number(element.dataset.subtotal || 0)
        };

    const main = element.querySelector('.zep-shipping-estimator__main');
    const heavy = element.querySelector('.zep-shipping-estimator__heavy');
    const note = element.querySelector('.zep-shipping-estimator__note');
    if (!main || !heavy) return;

    const rate = state.unknown
      ? null
      : estimate(state.grams);

    if (context === 'pdp') {
      if (rate === null) {
        clearPdpPresentation(main);
        setText(main, 'Livrare în România');
        setHidden(heavy, true);
        if (note) {
          setHidden(note, false);
          setText(note, 'Cost calculat în coș');
        }
        element.dataset.estimateStatus = 'unknown';
        return;
      }

      const label = 'Livrare: ' + formatRate(rate) + ' lei';
      applyPdpPresentation(main, label);
      setHidden(heavy, state.grams <= 40000);
      if (note) {
        setHidden(note, state.grams > 40000);
        setText(note, 'Livrare în România');
      }
    } else {
      clearPdpPresentation(main);
      if (rate === null) {
        setText(main, 'Livrare: Cost calculat în checkout');
        setHidden(heavy, true);
        element.dataset.estimateStatus = 'unknown';
        return;
      }

      const suffix = context === 'minicart' ? ' · 1–3 zile lucrătoare' : '';
      setText(main, 'Livrare: ' + formatRate(rate) + ' lei' + suffix);
      setHidden(heavy, context === 'minicart' || state.grams <= 40000);
    }
    element.dataset.estimateStatus = 'estimated';
    element.dataset.estimatedRate = String(rate);
    element.dataset.estimatedWeight = String(state.grams);
  };

  let cartRefreshTimer = null;

  const refreshCartEstimators = async () => {
    const elements = document.querySelectorAll(
      '[data-zep-shipping-estimator][data-context="cart"], [data-zep-shipping-estimator][data-context="minicart"]'
    );
    if (!elements.length) return;

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;

      const cartState = await response.json();
      const isEmpty = Number(cartState.item_count || 0) === 0;
      const hasZeroWeight = !isEmpty && (cartState.items || []).some(
        (item) => item.requires_shipping && Number(item.grams || 0) === 0
      );

      elements.forEach((element) => {
        element.hidden = isEmpty;
        if (isEmpty) {
          delete element.dataset.estimatedRate;
          delete element.dataset.estimatedWeight;
          element.dataset.estimateStatus = 'empty';
          return;
        }

        element.dataset.weight = String(Number(cartState.total_weight || 0));
        element.dataset.subtotal = String(Number(cartState.total_price || 0));
        element.dataset.hasZeroWeight = String(hasZeroWeight);
        render(element);
      });
    } catch (_error) {
      // Pastreaza ultima estimare vizibila daca endpoint-ul cart nu raspunde.
    }
  };

  const scheduleCartRefresh = (delay = 120) => {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(refreshCartEstimators, delay);
  };

  const isCartRequest = (url = '') => /\/cart(?:\/(?:add|change|update|clear))?(?:\.js)?(?:\?|$)/.test(String(url));

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'theme:cart:change'].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleCartRefresh());
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(
      'a[href*="/cart/change"], [data-cart-remove], [data-remove-item], .cart__remove, .mini_cart_remove, .js_plus, .js_minus'
    )) scheduleCartRefresh(700);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches(
      'input[name="updates[]"], input[name="quantity"], [data-cart-quantity], .cart__qty-input'
    )) scheduleCartRefresh(700);
  });

  if (window.jQuery) {
    window.jQuery(document).on('ajaxComplete.zepShippingEstimator', (_event, _xhr, settings) => {
      if (settings && isCartRequest(settings.url)) scheduleCartRefresh();
    });
  }

  const init = (element) => {
    if (!element || element.dataset.zepEstimatorReady === 'true') return;
    element.dataset.zepEstimatorReady = 'true';
    render(element);

    if (element.dataset.context === 'pdp') {
      const form = element.closest('form[data-type="add-to-cart-form"]') || element.closest('form');
      if (form && !form.dataset.zepShippingObserved) {
        form.dataset.zepShippingObserved = 'true';
        let queued = false;
        const scheduleRender = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {
            queued = false;
            render(element);
          });
        };

        ['change', 'input', 'click'].forEach((eventName) => {
          form.addEventListener(eventName, scheduleRender);
        });
        new MutationObserver(scheduleRender).observe(form, {
          childList: true,
          characterData: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'disabled']
        });
      }
    }
  };

  const initAll = (root = document) => {
    if (root.nodeType === 1 && root.matches('[data-zep-shipping-estimator]')) init(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-zep-shipping-estimator]').forEach(init);
    }
  };

  installPdpPresentationStyles();
  window.ZepShippingEstimator = Object.freeze({ RATE_RULES, estimate, render, initAll });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initAll(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleCartRefresh(0), { once: true });
  } else {
    scheduleCartRefresh(0);
  }
})();


(() => {
  if (window.ZepProductRecommendations) return;

  const cache = new Map();
  const load = (productId, limit = 10, intent = 'related') => {
    const id = String(productId || '');
    if (!id) return Promise.resolve({ products: [] });

    const key = `${id}:${limit}:${intent}`;
    if (cache.has(key)) return cache.get(key);

    const request = fetch(
      `/recommendations/products.json?product_id=${encodeURIComponent(id)}&limit=${limit}&intent=${encodeURIComponent(intent)}`
    )
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('Recommendations unavailable')))
      .catch((error) => {
        cache.delete(key);
        throw error;
      });
    cache.set(key, request);
    return request;
  };

  window.ZepProductRecommendations = Object.freeze({ load });
})();


(() => {
  if (window.ZepPdpContentPipeline) return;

  const entries = [];
  let observer = null;
  let queued = false;

  const hasActiveEntries = () => entries.some((entry) => entry.active);
  const stopObserver = () => {
    observer?.disconnect();
    observer = null;
  };

  const run = () => {
    queued = false;
    entries.forEach((entry) => {
      if (!entry.active) return;
      try {
        entry.active = entry.task() !== true;
      } catch (_error) {
        entry.active = true;
      }
    });
    if (!hasActiveEntries()) stopObserver();
  };

  const startObserver = () => {
    if (observer || !document.documentElement) return;
    observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  function schedule() {
    if (queued) return;
    queued = true;
    startObserver();
    requestAnimationFrame(run);
  }

  const register = (task) => {
    entries.push({ task, active: true });
    schedule();
  };

  const reset = () => {
    entries.forEach((entry) => { entry.active = true; });
    schedule();
  };

  window.ZepPdpContentPipeline = Object.freeze({ register, reset });
  document.addEventListener('shopify:section:load', reset);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  window.addEventListener('load', schedule, { once: true });
})();

(() => {
  if (window.ZepPdpLivePipeline) return;

  const tasks = new Set();
  let observer = null;
  let queued = false;

  const run = () => {
    queued = false;
    tasks.forEach((task) => {
      try {
        task();
      } catch (_error) {
        // Pastreaza celelalte protectii active daca un modul extern este temporar indisponibil.
      }
    });
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  };

  const start = () => {
    schedule();
    if (observer || !document.documentElement) return;
    observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'hidden', 'data-button-status']
    });
  };

  const register = (task) => {
    if (typeof task !== 'function') return;
    tasks.add(task);
    start();
  };

  window.ZepPdpLivePipeline = Object.freeze({ register, schedule });
  document.addEventListener('change', schedule);
  document.addEventListener('contentUpdated', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(()=>{const K=[['putere',100],['capacitat',95],['cilindr',94],['debit',92],['latim',90],['diametr',88],['presiune',86],['tensiune',84],['greutate',82],['masa',82],['turatie',80],['viteza',78],['inaltim',77],['lungim',76],['adancim',75],['volum',74],['vascozitate',72],['destinat',70],['frecventa',68],['tip filtru',66],['autonomie',64],['acumulator',62],['tip',40]],B=['acustic','clasa','consum','panou','rebobin'],N=v=>(v||'').normalize('NFD').split('').filter(c=>{const n=c.charCodeAt(0);return n<768||n>879}).join('').toLowerCase().trim(),C=r=>{const a=[],x=(l,v,i)=>{l=(l||'').trim().replace(/:$/,'').trim();v=(v||'').trim().replace(/^:/,'').trim();const n=N(l);if(!l||!v||l.length>55||v.length>120||B.some(k=>n.includes(k)))return;const p=K.find(([k])=>n.includes(k));if(p)a.push({label:l,value:v,score:p[1],index:i})};r.querySelectorAll('tr').forEach((q,i)=>{const c=q.querySelectorAll('th,td');if(c.length>1)x(c[0].innerText,c[1].innerText,i)});r.innerText.split(String.fromCharCode(10)).forEach((l,i)=>{const s=l.indexOf(':');if(s>1&&s<56)x(l.slice(0,s),l.slice(s+1),i+1000)});return a.sort((u,v)=>v.score-u.score||u.index-v.index).filter((u,i,z)=>z.findIndex(v=>N(v.label)===N(u.label))===i).slice(0,4)},S=()=>{if(document.getElementById('zep-pdp-highlights-style'))return;const s=document.createElement('style');s.id='zep-pdp-highlights-style';s.textContent='.zep-pdp-highlights{margin:12px 0;padding:12px;border:1px solid #e3e7eb;border-radius:12px;background:#fff}.zep-pdp-highlights__title{margin:0 0 9px;font-size:14px;font-weight:800;color:#20242a}.zep-pdp-highlights__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px;margin:0}.zep-pdp-highlights__item{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:8px;min-height:42px;padding:8px 10px;border-radius:9px;background:#f5f7f8}.zep-pdp-highlights dt{margin:0;font-size:12px;line-height:1.25;color:#626872}.zep-pdp-highlights dd{margin:0;font-size:13px;line-height:1.25;font-weight:800;color:#17191c;text-align:right}@media(max-width:420px){.zep-pdp-highlights__grid{grid-template-columns:1fr}.zep-pdp-highlights__item{min-height:38px}}';document.head.appendChild(s)},R=()=>{const d=document.querySelector('#tab_des');if(!d)return;const a=C(d);if(a.length<3)return;document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(f=>{if(f.querySelector('.zep-pdp-highlights'))return;const c=f.querySelector('.zep-buy-confidence');if(!c)return;S();const s=document.createElement('section'),h=document.createElement('h2'),l=document.createElement('dl');s.className='zep-pdp-highlights';h.className='zep-pdp-highlights__title';l.className='zep-pdp-highlights__grid';h.textContent='Caracteristici esentiale';a.forEach(o=>{const w=document.createElement('div'),t=document.createElement('dt'),v=document.createElement('dd');w.className='zep-pdp-highlights__item';t.textContent=o.label;v.textContent=o.value;w.append(t,v);l.appendChild(w)});s.append(h,l);f.insertBefore(s,c)})};window.ZepPdpContentPipeline.register(()=>{const d=document.querySelector('#tab_des'),f=[...document.querySelectorAll('form[data-type="add-to-cart-form"]')];if(!d||!f.length||f.some(x=>!x.querySelector('.zep-buy-confidence')))return false;R();return true})})();

(()=>{if(window.__zepSoldoutRescueV2)return;window.__zepSoldoutRescueV2=!0;const z="zep-soldout-rescue-style",C=new Set(["accesoriu","accesorii","alimentare","compatibil","compatibila","compatibile","pentru","produs","produse","profesional","profesionala","set","buc","zep"]),E=()=>{if(document.getElementById(z))return;const e=document.createElement("style");e.id=z,e.textContent='.zep-soldout-rescue{margin:12px 0;padding:14px;border:1px solid #efc7c7;border-radius:12px;background:#fffafa}.zep-soldout-rescue__eyebrow{display:flex;align-items:center;gap:7px;margin:0 0 5px;font-size:12px;font-weight:800;color:#a51f1f}.zep-soldout-rescue__dot{width:9px;height:9px;border-radius:50%;background:#c62828}.zep-soldout-rescue__title{margin:0 0 5px;font-size:17px;line-height:1.3;font-weight:800;color:#17191c}.zep-soldout-rescue__intro{margin:0 0 12px;font-size:13px;line-height:1.5;color:#515760}.zep-soldout-rescue__status{margin:0 0 8px;font-size:12px;font-weight:750;color:#217a3c}.zep-soldout-rescue__status[data-empty="true"]{color:#5b6169}.zep-soldout-rescue__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}.zep-soldout-rescue__card{display:grid;grid-template-columns:58px minmax(0,1fr);gap:8px;align-items:center;padding:8px;border:1px solid #e1e5e9;border-radius:9px;background:#fff;color:#17191c;text-decoration:none;transition:border-color .2s ease,box-shadow .2s ease}.zep-soldout-rescue__card:hover{border-color:#9aa5b1;box-shadow:0 3px 10px rgba(16,24,40,.08)}.zep-soldout-rescue__image{width:58px;height:58px;object-fit:contain;border-radius:6px;background:#f6f7f8}.zep-soldout-rescue__name{display:-webkit-box;overflow:hidden;-webkit-line-clamp:2;-webkit-box-orient:vertical;font-size:12px;line-height:1.3;font-weight:700}.zep-soldout-rescue__price{display:block;margin-top:4px;font-size:13px;font-weight:800;color:#c62828}.zep-soldout-rescue__actions{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:11px;padding-top:10px;border-top:1px solid #eadede}.zep-soldout-rescue__help{margin:0;font-size:12px;line-height:1.4;color:#555b63}.zep-soldout-rescue__call{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;min-height:38px;padding:8px 13px;border-radius:8px;background:#10104b;color:#fff!important;font-size:12px;font-weight:800;text-decoration:none}.zep-soldout-rescue__call:hover{background:#202066}.zep-soldout-rescue[hidden]{display:none!important}@media(max-width:767px){.zep-soldout-rescue__grid{grid-template-columns:1fr}.zep-soldout-rescue__card{grid-template-columns:64px minmax(0,1fr)}.zep-soldout-rescue__image{width:64px;height:64px}.zep-soldout-rescue__actions{align-items:flex-start;flex-direction:column}.zep-soldout-rescue__call{width:100%}}',document.head.appendChild(e)},r=(e,o,t)=>{const i=document.createElement(e);return o&&(i.className=o),t&&(i.textContent=t),i},j=e=>String(e||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase().replace(/[^a-z0-9]+/g," ").trim(),y=e=>[...new Set(j(e).split(" ").filter(o=>o.length>=3&&!C.has(o)&&!/^\d+$/.test(o)))],k=(e,o)=>{const t=y(e),i=new Set(y(o)),c=t.filter(a=>i.has(a));return c.length>=2||c.some(a=>/\d/.test(a)&&a.length>=4)},w=e=>new Intl.NumberFormat("ro-RO",{style:"currency",currency:"RON"}).format(Number(e||0)/100),v=()=>document.querySelector("[data-product-id]")?.dataset.productId||"",I=()=>document.querySelector("h1")?.textContent?.replace(/\s+/g," ").trim()||document.title,h=e=>!!(e&&!e.hidden&&e.getClientRects().length&&getComputedStyle(e).visibility!=="hidden"),R=e=>{const o=e.querySelector("#js-pr-unavailable"),t=e.querySelector(".js-btn-sold-out"),i=e.querySelector('.js_add_to_cart_button, [name="add"]');return h(o)||h(t)||!!(i&&i.disabled&&!h(i))},b=(e,o)=>{const t=e.querySelector(".zep-soldout-rescue__grid"),i=e.querySelector(".zep-soldout-rescue__status"),c=I(),a=String(v()),p=o.filter(n=>n.available&&String(n.id)!==a&&k(c,n.title)).slice(0,3);t.textContent="",p.forEach(n=>{const u=r("a","zep-soldout-rescue__card");u.href=n.url,u.setAttribute("aria-label",`${n.title}, ${w(n.price)}`);const s=r("img","zep-soldout-rescue__image");s.src=String(n.featured_image||"").replace(/^\/\//,"https://"),s.alt="",s.loading="lazy",s.width=64,s.height=64,s.addEventListener("error",()=>s.remove(),{once:!0});const m=r("span"),g=r("span","zep-soldout-rescue__name",n.title),_=r("span","zep-soldout-rescue__price",w(n.price));m.append(g,_),u.append(s,m),t.appendChild(u)});const d=t.children.length;i.textContent=d?`${d} ${d===1?"alternativ\u0103 apropiat\u0103 disponibil\u0103":"alternative apropiate disponibile"}`:"Nu am g\u0103sit automat o alternativ\u0103 suficient de apropiat\u0103.",i.dataset.empty=d?"false":"true",t.hidden=d===0},T=(e,o)=>{if(e.querySelector(".zep-soldout-rescue"))return;E();const t=r("section","zep-soldout-rescue"),i=`zep-soldout-rescue-title-${o}`;t.setAttribute("aria-labelledby",i);const c=r("p","zep-soldout-rescue__eyebrow"),a=r("span","zep-soldout-rescue__dot");a.setAttribute("aria-hidden","true"),c.append(a,document.createTextNode("Indisponibil momentan"));const p=r("h2","zep-soldout-rescue__title","Te ajut\u0103m s\u0103 g\u0103se\u0219ti solu\u021Bia potrivit\u0103");p.id=i;const d=r("p","zep-soldout-rescue__intro","P\u0103str\u0103m toate detaliile produsului pentru compara\u021Bie \u0219i afi\u0219\u0103m doar alternative suficient de apropiate care pot fi comandate acum."),n=r("p","zep-soldout-rescue__status","Verific\u0103m alternativele disponibile\u2026");n.setAttribute("aria-live","polite");const u=r("div","zep-soldout-rescue__grid"),s=r("div","zep-soldout-rescue__actions"),m=r("p","zep-soldout-rescue__help","Vrei s\u0103 afli c\xE2nd revine sau ai nevoie de o alternativ\u0103 verificat\u0103?"),g=r("a","zep-soldout-rescue__call","Sun\u0103 un specialist ZEP");const A=window.matchMedia("(hover: none) and (pointer: coarse)").matches;g.href=A?"tel:+40230706399":"/pages/contact",g.textContent=A?"Sun\u0103: 0230 706 399":"Contacteaz\u0103 un specialist ZEP",g.setAttribute("aria-label",A?"Sun\u0103 la 0230 706 399":"Deschide pagina de contact ZEP"),s.append(m,g),t.append(c,p,d,n,u,s);const _=e.querySelector(".cms-product-meta");_?_.insertAdjacentElement("afterend",t):e.appendChild(t);const q=v();if(!q){b(t,[]);return}window.ZepProductRecommendations.load(q,10,"related").then(f=>b(t,f.products||[])).catch(()=>b(t,[]))},l=()=>{document.querySelectorAll('#product-single form[data-type="add-to-cart-form"], .product-single form[data-type="add-to-cart-form"], .main-product form[data-type="add-to-cart-form"]').forEach((e,o)=>{const t=e.querySelector(".zep-soldout-rescue");R(e)?T(e,o):t&&t.remove()})};window.ZepPdpLivePipeline.register(l)})();
(()=>{const I='zep-smart-comparison-style',N=v=>(v||'').normalize('NFD').split('').filter(c=>{const x=c.charCodeAt(0);return x<768||x>879}).join('').toLowerCase().replaceAll(',',' ').replaceAll('.',' ').replaceAll('/',' ').replaceAll('-',' ').trim(),W=new Set(['pentru','din','si','sau','plus','model','produs','elefant','yato','zep','broman','rosu','negru','inox']),T=v=>N(v).split(' ').filter(x=>x.length>2&&!W.has(x)),Q=(a,b)=>{const x=new Set(T(a));return[...new Set(T(b))].filter(y=>x.has(y)).length},K=[['putere',['putere','putere motor']],['capacitate',['capacitate','volum cuva','volum recipient','capacitatea recipientului de praf']],['cilindree',['cilindree','capacitate cilindrica']],['debit',['debit']],['productivitate',['productivitate','capacitate productie']],['diametru',['diametru']],['latime',['latime','latime lucru']],['presiune',['presiune']],['tensiune',['tensiune','voltaj']],['greutate',['greutate','masa']],['turatie',['turatie','viteza rotatie']],['vascozitate',['vascozitate']],['destinatie',['destinat pentru']],['tip',['tip']]],D={putere:'Putere',capacitate:'Capacitate',cilindree:'Cilindree',debit:'Debit',productivitate:'Productivitate',diametru:'Diametru',latime:'Latime de lucru',presiune:'Presiune',tensiune:'Tensiune',greutate:'Greutate',turatie:'Turatie',vascozitate:'Vascozitate',destinatie:'Destinat pentru',tip:'Tip'},P=h=>{const d=document.createElement('div');d.innerHTML=h||'';const o={};d.querySelectorAll('li,p,tr').forEach(e=>{const t=e.innerText.trim(),i=t.indexOf(':');if(i<1||i>65)return;const l=N(t.slice(0,i)),v=t.slice(i+1).trim();if(!v||v.length>140)return;const k=K.find(x=>x[1].some(y=>l===y||l.startsWith(y)));k&&!o[k[0]]&&(o[k[0]]=v)});return o},M=c=>new Intl.NumberFormat('ro-RO',{minimumFractionDigits:Number(c)%100?2:0,maximumFractionDigits:2}).format(Number(c||0)/100)+' lei',E=(t,c,x)=>{const e=document.createElement(t);return c&&(e.className=c),x&&(e.textContent=x),e},A=()=>{if(document.getElementById(I))return;const s=E('style');s.id=I,s.textContent='.zep-smart-comparison{margin:13px 0;border:1px solid #dfe4ea;border-radius:12px;background:#fff;overflow:hidden}.zep-smart-comparison summary{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:13px 14px;cursor:pointer;list-style:none;font-size:15px;font-weight:800;color:#17191c}.zep-smart-comparison summary::-webkit-details-marker{display:none}.zep-smart-comparison summary::after{content:"+";display:grid;place-items:center;width:25px;height:25px;border-radius:50%;background:#f0f3f6;color:#10104b;font-size:18px}.zep-smart-comparison[open] summary::after{content:"–"}.zep-smart-comparison__hint{display:block;margin-top:-5px;padding:0 14px 11px;font-size:12px;color:#60666e}.zep-smart-comparison__scroll{overflow-x:auto;padding:0 12px 13px}.zep-smart-comparison__table{display:grid;min-width:650px;border:1px solid #e5e8eb;border-radius:10px;overflow:hidden}.zep-smart-comparison__row{display:grid;grid-template-columns:120px repeat(3,minmax(150px,1fr))}.zep-smart-comparison__row>*{padding:9px;border-right:1px solid #e5e8eb;border-bottom:1px solid #e5e8eb}.zep-smart-comparison__row>*:last-child{border-right:0}.zep-smart-comparison__row:last-child>*{border-bottom:0}.zep-smart-comparison__label{background:#f7f8fa;font-size:12px;font-weight:800;color:#4d535a}.zep-smart-comparison__cell{font-size:12px;line-height:1.35;color:#292e34}.zep-smart-comparison__head{align-items:stretch}.zep-smart-comparison__product{display:flex;flex-direction:column;gap:6px;min-height:165px}.zep-smart-comparison__image{width:64px;height:64px;object-fit:contain;align-self:center}.zep-smart-comparison__name{font-size:12px;line-height:1.3;font-weight:750}.zep-smart-comparison__price{font-size:14px;font-weight:900;color:#c62828}.zep-smart-comparison__badge{align-self:flex-start;padding:2px 6px;border-radius:999px;background:#eaf6ee;color:#217a3c;font-size:10px;font-weight:800}.zep-smart-comparison__link{margin-top:auto;display:inline-flex;justify-content:center;padding:7px 8px;border-radius:7px;background:#10104b;color:#fff!important;text-decoration:none;font-size:11px;font-weight:800}.zep-smart-comparison__current{outline:2px solid #e4ad00;outline-offset:-2px;background:#fffdf5}@media(max-width:767px){.zep-smart-comparison__scroll{padding-left:8px;padding-right:8px}.zep-smart-comparison summary{padding:12px}.zep-smart-comparison__hint{padding-left:12px}}',document.head.appendChild(s)},G=p=>{const d=E('div','zep-smart-comparison__product'+(p.current?' zep-smart-comparison__current':'')),i=E('img','zep-smart-comparison__image');i.src=String(p.featured_image||p.image||'').startsWith('//')?'https:'+String(p.featured_image):p.featured_image||p.image||'',i.alt=p.title,i.loading='lazy',i.width=64,i.height=64;const n=E('span','zep-smart-comparison__name',p.title),v=E('span','zep-smart-comparison__price',M(p.price)),b=E('span','zep-smart-comparison__badge',p.current?'Produsul acesta':'In stoc');d.append(i,n,v,b);if(!p.current){const a=E('a','zep-smart-comparison__link','Vezi produsul');a.href=p.url,d.appendChild(a)}return d},R=(form,current,products)=>{const currentSpecs=P(document.querySelector('#tab_des')?.innerHTML||''),prepared=products.map(p=>({...p,specs:P(p.description)})),rows=K.map(x=>x[0]).filter(k=>[currentSpecs[k],...prepared.map(p=>p.specs[k])].filter(Boolean).length>=2).slice(0,5);if(rows.length<2)return;A();const box=E('details','zep-smart-comparison'),sum=E('summary','','Compara cu 2 alternative'),hint=E('span','zep-smart-comparison__hint','Vezi rapid diferentele importante, fara sa parasesti pagina.'),scroll=E('div','zep-smart-comparison__scroll'),table=E('div','zep-smart-comparison__table'),head=E('div','zep-smart-comparison__row zep-smart-comparison__head'),blank=E('div','zep-smart-comparison__label','Model');head.append(blank,G(current),...prepared.map(G)),table.appendChild(head),rows.forEach(k=>{const row=E('div','zep-smart-comparison__row'),label=E('div','zep-smart-comparison__label',D[k]);row.append(label,E('div','zep-smart-comparison__cell',currentSpecs[k]||'—'),...prepared.map(p=>E('div','zep-smart-comparison__cell',p.specs[k]||'—'))),table.appendChild(row)}),scroll.appendChild(table),box.append(sum,hint,scroll);const pkg=form.querySelector('.zep-package-contents'),hi=form.querySelector('.zep-pdp-highlights'),conf=form.querySelector('.zep-buy-confidence');pkg?pkg.insertAdjacentElement('afterend',box):hi?hi.insertAdjacentElement('afterend',box):conf?form.insertBefore(box,conf):form.appendChild(box)},U=()=>{const form=document.querySelector('form[data-type="add-to-cart-form"]');if(!form||form.querySelector('.zep-smart-comparison'))return;const meta=document.querySelector('meta[name="taggrs-product"]'),id=document.querySelector('[data-product-id]')?.dataset.productId;let current={};try{current=JSON.parse(meta?.content||'{}')}catch{}if(!id||!current.title)return;current.current=true,current.image=document.querySelector('.product-single img[alt],#product-single img[alt]')?.src||'',current.price=current.price||Number(String(document.querySelector('#js-product-price')?.textContent||'').replaceAll('.','').replace(',','.').replaceAll(' ',''))*100;window.ZepProductRecommendations.load(id,10,"related").then(d=>{const related=(d.products||[]).filter(p=>p.available).map(p=>({...p,score:Q(current.title,p.title)})).filter(p=>p.score>=2).sort((a,b)=>b.score-a.score||Math.abs(a.price-current.price)-Math.abs(b.price-current.price)).slice(0,2);related.length===2&&R(form,current,related)}).catch(()=>{})};window.ZepPdpContentPipeline.register(()=>{const f=document.querySelector('form[data-type="add-to-cart-form"]'),m=document.querySelector('meta[name="taggrs-product"]'),i=document.querySelector('[data-product-id]')?.dataset.productId;if(!f||!m||!i)return false;U();return true})})();
(() => {
  const arrangeProductBlocks = () => {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const confidence = form.querySelector('.zep-buy-confidence');
    if (confidence) {
      const purchaseBlocks = [
        form.querySelector('[data-zep-shipping-estimator][data-context="pdp"]'),
        form.querySelector('.cms-product-meta'),
        form.querySelector('[class*="zep-app-slot--"][class*="easify_options_easify_product_options_bmnUNH"]'),
        form.querySelector('.product-iteam.flex.flex-wrap'),
        form.querySelector('buy-now'),
        form.querySelector('.zep-essential-specs'),
        form.querySelector('.zep-compatibility'),
        form.querySelector('.zep-pdp-highlights'),
        form.querySelector('.zep-expert-verdict')
      ].filter(Boolean);
      const purchaseOrderIsCorrect = purchaseBlocks.every((element, index) => (
        element.nextElementSibling === (purchaseBlocks[index + 1] || confidence)
      ));
      if (!purchaseOrderIsCorrect) {
        purchaseBlocks.forEach((element) => form.insertBefore(element, confidence));
      }
    }

    const comparisons = [...form.querySelectorAll('.zep-smart-comparison')];
    comparisons.slice(1).forEach((element) => element.remove());

    const pack = form.querySelector('.zep-package-contents');
    if (confidence && pack && confidence.nextElementSibling !== pack) {
      confidence.insertAdjacentElement('afterend', pack);
    }
    const anchor = pack || confidence;
    if (anchor && comparisons[0] && anchor.nextElementSibling !== comparisons[0]) {
      anchor.insertAdjacentElement('afterend', comparisons[0]);
    }
  };

  let queued = false;
  const scheduleArrange = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      arrangeProductBlocks();
    });
  };

  new MutationObserver(scheduleArrange).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrangeProductBlocks, { once: true });
  } else {
    arrangeProductBlocks();
  }
})();
(() => {
  if (window.__zepComparisonLayout) return;
  window.__zepComparisonLayout = true;

  let queued = false;
  const relocateComparison = () => {
    queued = false;
    const productSingle = document.querySelector('#product-single');
    const mainRow = productSingle?.querySelector(':scope > .row');
    const form = productSingle?.querySelector('form[data-type="add-to-cart-form"]');
    const comparison = productSingle?.querySelector('.zep-smart-comparison:not([data-zep-comparison-placeholder])');
    if (!productSingle || !mainRow || !form || !comparison) return;

    if (!form.querySelector('[data-zep-comparison-placeholder]')) {
      const placeholder = document.createElement('span');
      placeholder.className = 'zep-smart-comparison';
      placeholder.hidden = true;
      placeholder.dataset.zepComparisonPlaceholder = 'true';
      form.appendChild(placeholder);
    }

    if (comparison.previousElementSibling !== mainRow) {
      mainRow.insertAdjacentElement('afterend', comparison);
    }
  };

  const scheduleComparisonLayout = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(relocateComparison);
  };

  const startComparisonLayout = () => {
    const productSingle = document.querySelector('#product-single');
    if (!productSingle) return;
    new MutationObserver(scheduleComparisonLayout).observe(productSingle, {
      childList: true,
      subtree: true
    });
    scheduleComparisonLayout();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startComparisonLayout, { once: true });
  } else {
    startComparisonLayout();
  }
})();
(() => {
  if (window.__zepCompatibilityChecker) return;
  window.__zepCompatibilityChecker = true;

  const normalize = (value) => (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const partWords = [
    'amortizor', 'carburator', 'ambreiaj', 'demaror', 'bobina', 'aprindere',
    'filtru', 'bujie', 'lant', 'lama', 'pinion', 'rulment', 'garnitura',
    'membrana', 'piston', 'cilindru', 'fulie', 'curea', 'cutit', 'disc',
    'rezervor', 'maner', 'simering', 'duza', 'pompa ulei', 'piesa'
  ];
  const leadingPartPattern = new RegExp(`^(?:(?:set|kit|pachet)\\s+)?(?:${partWords
    .map((word) => normalize(word).replace(/\\s+/g, '\\s+'))
    .join('|')})(?:\\s|$)`);

  const ignoredWords = new Set([
    'drujba', 'motocoasa', 'motoferastrau', 'motocultor', 'generator', 'atomizor',
    'pulverizator', 'motor', 'masina', 'pompa', 'pentru', 'model', 'marca',
    'compatibil', 'compatibila', 'compatibilitate', 'cu', 'si', 'sau', 'de', 'din'
  ]);

  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const installStyles = () => {
    if (document.getElementById('zep-compatibility-style')) return;
    const style = create('style');
    style.id = 'zep-compatibility-style';
    style.textContent = '.zep-compatibility{margin:13px 0;border:1px solid #d9dfe7;border-radius:12px;background:#fff;overflow:hidden}.zep-compatibility summary{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px;cursor:pointer;list-style:none;font-size:15px;font-weight:850;color:#10104b}.zep-compatibility summary::-webkit-details-marker{display:none}.zep-compatibility summary:after{content:"+";display:grid;place-items:center;width:26px;height:26px;border-radius:50%;background:#f0f2f7;font-size:19px}.zep-compatibility[open] summary:after{content:"–"}.zep-compatibility__body{padding:0 14px 14px}.zep-compatibility__source{margin:0 0 10px;padding:9px 10px;border-radius:8px;background:#f7f8fa;color:#41464d;font-size:12px;line-height:1.4}.zep-compatibility__label{display:block;margin-bottom:6px;font-size:12px;font-weight:800;color:#24282d}.zep-compatibility__controls{display:grid;grid-template-columns:1fr auto;gap:7px}.zep-compatibility__input{min-width:0;height:42px;border:1px solid #bbc3ce;border-radius:8px;padding:0 10px;font-size:14px}.zep-compatibility__input:focus{outline:3px solid rgba(228,173,0,.24);border-color:#bd8d00}.zep-compatibility__check{border:0;border-radius:8px;padding:0 13px;background:#10104b;color:#fff;font-size:13px;font-weight:850;cursor:pointer}.zep-compatibility__result{display:none;margin-top:9px;padding:10px;border-radius:8px;font-size:12px;line-height:1.45}.zep-compatibility__result.is-success{display:block;background:#eaf7ee;color:#176b35}.zep-compatibility__result.is-uncertain{display:block;background:#fff5dc;color:#765300}.zep-compatibility__note{margin:9px 0 0;color:#68707a;font-size:11px;line-height:1.4}.zep-compatibility__phone{display:inline-flex;margin-top:8px;color:#10104b!important;font-size:12px;font-weight:850;text-decoration:underline}@media(max-width:480px){.zep-compatibility__controls{grid-template-columns:1fr}.zep-compatibility__check{height:42px}}';
    document.head.appendChild(style);
  };

  const mount = () => {
    if (document.querySelector('.zep-compatibility')) return;
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const titleElement = document.querySelector('h1');
    const descriptionElement = document.querySelector('#tab_des');
    if (!form || !titleElement || !descriptionElement) return;

    const title = titleElement.textContent.trim();
    const description = descriptionElement.innerText.trim();
    const normalizedTitle = normalize(title);
    const normalizedSource = normalize(`${title} ${description}`);
    const isPart = leadingPartPattern.test(normalizedTitle);
    const hasCompatibilityEvidence = /compatibil|potrivit pentru|se potriveste|cod oem|pentru modelele|pentru modelul/.test(normalizedSource)
      || (isPart && /\b[a-z]{2,}[ -]?\d{2,}[a-z0-9-]*\b/i.test(`${title} ${description}`));
    if (!isPart || !hasCompatibilityEvidence) return;

    installStyles();
    const box = create('details', 'zep-compatibility');
    const summary = create('summary', '', 'Verifica daca se potriveste utilajului meu');
    const body = create('div', 'zep-compatibility__body');
    const source = create('p', 'zep-compatibility__source');
    source.textContent = `Compatibilitate declarata in fisa: ${title}`;
    const label = create('label', 'zep-compatibility__label', 'Introdu marca si modelul exact');
    const controls = create('div', 'zep-compatibility__controls');
    const input = create('input', 'zep-compatibility__input');
    input.type = 'text';
    input.placeholder = 'Ex: Oleo-Mac 951';
    input.autocomplete = 'off';
    input.setAttribute('aria-label', 'Marca si modelul utilajului');
    const button = create('button', 'zep-compatibility__check', 'Verifica');
    button.type = 'button';
    const result = create('div', 'zep-compatibility__result');
    result.setAttribute('role', 'status');
    result.setAttribute('aria-live', 'polite');
    const note = create('p', 'zep-compatibility__note', 'Confirmarea automata foloseste numai informatiile declarate in fisa produsului. Pentru siguranta maxima, verifica si codul OEM sau dimensiunile piesei.');
    const phone = create('a', 'zep-compatibility__phone', 'Nu esti sigur? Suna la 0230 706 399');
    phone.href = 'tel:+40230706399';

    const check = () => {
      const query = normalize(input.value);
      const tokens = query.split(' ').filter((token) => token.length > 1 && !ignoredWords.has(token));
      result.className = 'zep-compatibility__result';
      if (tokens.length < 2) {
        result.classList.add('is-uncertain');
        result.textContent = 'Introdu atat marca, cat si modelul exact al utilajului.';
        return;
      }
      const confirmed = tokens.every((token) => normalizedSource.split(' ').includes(token));
      if (confirmed) {
        result.classList.add('is-success');
        result.textContent = `Compatibilitate confirmata in fisa produsului pentru: ${input.value.trim()}.`;
      } else {
        result.classList.add('is-uncertain');
        result.textContent = 'Nu exista o confirmare exacta pentru acest model in fisa produsului. Nu comanda inca; verifica modelul, codul OEM sau cere confirmarea unui specialist ZEP.';
      }
    };

    button.addEventListener('click', check);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        check();
      }
    });
    controls.append(input, button);
    body.append(source, label, controls, result, note, phone);
    box.append(summary, body);
    const confidence = form.querySelector('.zep-buy-confidence');
    const essentials = form.querySelector('.zep-essential-specs');
    if (confidence) form.insertBefore(box, confidence);
    else if (essentials) essentials.insertAdjacentElement('afterend', box);
    else form.appendChild(box);
  };

  window.ZepPdpContentPipeline.register(() => {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const title = document.querySelector('h1');
    const description = document.querySelector('#tab_des');
    if (!form || !title || !description) return false;
    mount();
    return true;
  });
})();

(() => {
  if (window.__zepPackageContents) return;
  window.__zepPackageContents = true;

  const STYLE_ID = 'zep-package-contents-style';
  const LABELS = new Set([
    'continut pachet',
    'continutul pachetului',
    'continut set',
    'continutul setului',
    'pachetul contine',
    'accesorii incluse',
    'set de livrare',
    'in cutie'
  ]);
  const REJECTED = [
    'setati continutul',
    'adaugati continutul',
    'nespecificat',
    'indisponibil',
    'consultati descrierea',
    'consultati imaginile'
  ];

  const clean = (value) => String(value || '')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const normalize = (value) => clean(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[.:]+$/, '')
    .trim();
  const isLabel = (value) => LABELS.has(normalize(value));
  const validItem = (value) => {
    const normalized = normalize(value);
    return normalized.length >= 2
      && normalized.length <= 160
      && !LABELS.has(normalized)
      && !REJECTED.some((phrase) => normalized.includes(phrase));
  };
  const splitItems = (value) => clean(value)
    .split(/\s*(?:\||;|\n|•)\s*/)
    .map((item) => clean(item).replace(/^[-–—✓]+\s*/, ''))
    .filter(validItem);

  const listItems = (list) => [...list.querySelectorAll(':scope > li')]
    .map((item) => clean(item.textContent).replace(/^[-–—✓]+\s*/, ''))
    .filter(validItem);

  const followingListItems = (anchor) => {
    let next = anchor?.nextElementSibling;
    while (next && next.matches('br, hr')) next = next.nextElementSibling;
    return next?.matches('ul, ol') ? listItems(next) : [];
  };

  const findItems = () => {
    const description = document.querySelector('#tab_des');
    if (!description) return [];
    const values = [];

    description.querySelectorAll('h2, h3, h4').forEach((heading) => {
      if (isLabel(heading.textContent)) values.push(...followingListItems(heading));
    });

    description.querySelectorAll('p, li').forEach((block) => {
      const text = clean(block.textContent);
      const separator = text.indexOf(':');
      if (separator >= 1 && isLabel(text.slice(0, separator))) {
        const inlineItems = splitItems(text.slice(separator + 1));
        if (inlineItems.length) values.push(...inlineItems);
        else values.push(...followingListItems(block));
        return;
      }

      const labelNode = block.querySelector('strong, b');
      if (labelNode && isLabel(labelNode.textContent)) {
        const remainder = clean(text.slice(clean(labelNode.textContent).length)).replace(/^:\s*/, '');
        const inlineItems = splitItems(remainder);
        if (inlineItems.length) values.push(...inlineItems);
        else values.push(...followingListItems(block));
      }
    });

    description.querySelectorAll('tr').forEach((row) => {
      const cells = row.querySelectorAll(':scope > th, :scope > td');
      if (cells.length < 2 || !isLabel(cells[0].textContent)) return;
      const nestedList = cells[1].querySelector('ul, ol');
      values.push(...(nestedList ? listItems(nestedList) : splitItems(cells[1].textContent)));
    });

    return values
      .filter((item, index, all) => all.findIndex((candidate) => normalize(candidate) === normalize(item)) === index)
      .slice(0, 16);
  };

  const addStyle = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '.zep-package-contents{max-width:1170px;margin:18px auto;border:1px solid #dfe5e1;border-radius:12px;background:#fbfdfb;overflow:hidden}.zep-package-contents summary{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 16px;cursor:pointer;list-style:none}.zep-package-contents summary::-webkit-details-marker{display:none}.zep-package-contents__heading{display:flex;align-items:center;gap:9px;min-width:0}.zep-package-contents__heading:before{content:"✓";display:grid;place-items:center;flex:0 0 23px;width:23px;height:23px;border-radius:50%;background:#e6f5eb;color:#218643;font-weight:900}.zep-package-contents__title{color:#17191c;font-size:15px;font-weight:850}.zep-package-contents__count{display:inline-flex;align-items:center;gap:7px;color:#217a3c;font-size:11px;font-weight:800;white-space:nowrap}.zep-package-contents__count:after{content:"+";display:grid;place-items:center;width:24px;height:24px;border-radius:50%;background:#eef2ef;color:#174f29;font-size:17px}.zep-package-contents[open] .zep-package-contents__count:after{content:"–"}.zep-package-contents summary:focus-visible{outline:3px solid rgba(33,134,67,.22);outline-offset:-3px}.zep-package-contents__list{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px 18px;margin:0;padding:0 16px 15px 50px;list-style:none;border-top:1px solid #e6ebe7}.zep-package-contents__item{position:relative;padding-top:10px;padding-left:18px;color:#383e45;font-size:12.5px;line-height:1.4}.zep-package-contents__item::before{content:"✓";position:absolute;left:0;top:10px;color:#218643;font-weight:900}@media(max-width:767px){.zep-package-contents{margin:14px 10px}.zep-package-contents summary{padding:13px 14px}.zep-package-contents__list{grid-template-columns:1fr;padding:0 14px 14px 38px}.zep-package-contents__item{padding-top:9px}.zep-package-contents__item::before{top:9px}}';
    document.head.appendChild(style);
  };

  const render = () => {
    if (document.querySelector('.zep-package-contents')) return;
    const description = document.querySelector('#tab_des');
    if (!description) return;
    const items = findItems();
    if (!items.length) return;

    addStyle();
    const section = document.createElement('details');
    section.className = 'zep-package-contents';
    section.dataset.zepSource = 'product-description';
    section.setAttribute('aria-labelledby', 'zep-package-contents-title');

    const summary = document.createElement('summary');
    const heading = document.createElement('span');
    heading.className = 'zep-package-contents__heading';
    const title = document.createElement('span');
    title.id = 'zep-package-contents-title';
    title.className = 'zep-package-contents__title';
    title.textContent = 'Ce primești în pachet';
    const count = document.createElement('span');
    count.className = 'zep-package-contents__count';
    count.textContent = items.length === 1 ? '1 element inclus' : `${items.length} elemente incluse`;
    heading.appendChild(title);
    summary.append(heading, count);

    const list = document.createElement('ul');
    list.className = 'zep-package-contents__list';
    items.forEach((item) => {
      const entry = document.createElement('li');
      entry.className = 'zep-package-contents__item';
      entry.textContent = item;
      list.appendChild(entry);
    });
    section.append(summary, list);

    const faq = document.querySelector('.zep-smart-faq');
    const tabSection = description.closest('.tab_product');
    if (faq) faq.insertAdjacentElement('beforebegin', section);
    else if (tabSection) tabSection.insertAdjacentElement('afterend', section);
    else description.insertAdjacentElement('afterend', section);
  };

  window.ZepPdpContentPipeline.register(() => {
    const description = document.querySelector('#tab_des');
    if (!description) return false;
    render();
    return true;
  });
})();

(() => {
  if (window.__zepSmartFaq) return;
  window.__zepSmartFaq = true;

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const installStyles = () => {
    if (document.getElementById('zep-smart-faq-style')) return;
    const style = create('style');
    style.id = 'zep-smart-faq-style';
    style.textContent = '.zep-smart-faq{max-width:1200px;margin:24px auto;padding:0 15px}.zep-smart-faq__box{border:1px solid #dfe4ea;border-radius:14px;background:#fff;overflow:hidden}.zep-smart-faq__title{margin:0;padding:17px 18px 8px;color:#17191c;font-size:21px;line-height:1.25}.zep-smart-faq__intro{margin:0;padding:0 18px 14px;color:#626a73;font-size:13px}.zep-smart-faq__item{border-top:1px solid #e7eaee}.zep-smart-faq__item summary{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:14px 18px;cursor:pointer;list-style:none;color:#20242a;font-size:14px;font-weight:800}.zep-smart-faq__item summary::-webkit-details-marker{display:none}.zep-smart-faq__item summary:after{content:"+";display:grid;flex:0 0 25px;place-items:center;width:25px;height:25px;border-radius:50%;background:#f0f2f6;color:#10104b;font-size:18px}.zep-smart-faq__item[open] summary:after{content:"–"}.zep-smart-faq__item summary:focus-visible{outline:3px solid rgba(228,173,0,.3);outline-offset:-3px}.zep-smart-faq__answer{margin:0;padding:0 18px 15px;color:#4b525a;font-size:13px;line-height:1.55}@media(max-width:767px){.zep-smart-faq{margin:18px auto;padding:0 10px}.zep-smart-faq__title{font-size:18px}.zep-smart-faq__item summary{padding:13px 14px}.zep-smart-faq__answer{padding:0 14px 14px}}';
    document.head.appendChild(style);
  };

  const mount = () => {
    if (document.querySelector('.zep-smart-faq')) return;
    const description = document.querySelector('#tab_des');
    const productArea = document.querySelector('#product-single, .product-single, .main-product');
    if (!description || !productArea) return;

    const questions = [];
    const add = (question, answer, stableForSchema = true, productSpecific = true) => {
      const safeAnswer = clean(answer);
      if (!safeAnswer || questions.some((item) => item.question === question)) return;
      questions.push({ question, answer: safeAnswer.slice(0, 360), stableForSchema, productSpecific });
    };

    const essentials = document.querySelector('.zep-pdp-highlights, .zep-essential-specs');
    if (essentials) {
      const labels = [...essentials.querySelectorAll('dt')];
      const pairs = labels.map((label) => {
        const value = label.nextElementSibling;
        return value ? `${clean(label.textContent)}: ${clean(value.textContent)}` : '';
      }).filter(Boolean);
      if (pairs.length) add('Care sunt specificațiile esențiale ale produsului?', `${pairs.slice(0, 6).join('; ')}.`);
    }

    const packageBox = document.querySelector('.zep-package-contents');
    if (packageBox) {
      const items = [...new Set([...packageBox.querySelectorAll('li')]
        .map((item) => clean(item.textContent).replace(/^✓\s*/, ''))
        .filter(Boolean))];
      if (items.length >= 2) add('Ce primesc în pachet?', `Pachetul conține: ${items.slice(0, 12).join(', ')}.`);
    }

    const descriptionText = clean(description.innerText);
    const compatibilityMatch = descriptionText.match(/[^.]{0,55}(?:compatibil(?:a|e)? pentru modelele|cod OEM)[^.]{0,280}/i);
    if (compatibilityMatch && /\d/.test(compatibilityMatch[0])) {
      add('Cu ce mărci sau modele este compatibil produsul?', `${clean(compatibilityMatch[0])}.`);
    }

    const shipping = document.querySelector('.zep-shipping-estimator');
    if (shipping) {
      const shippingText = clean(shipping.innerText).replace(/(Livrare in (?:24.?72 ore|1.?3 zile lucratoare))(?:\s+\1)+/gi, '$1');
      if (/\d/.test(shippingText)) add('Care sunt costul și termenul estimat de livrare?', shippingText.slice(0, 280), false, false);
    }

    const orderText = clean(document.querySelector('form[data-type="add-to-cart-form"]')?.innerText);
    const availability = orderText.match(/Disponibilitate:\s*(În stoc|In stoc|Indisponibil)/i);
    if (availability) {
      const inStock = !/indisponibil/i.test(availability[1]);
      add(
        'Produsul este disponibil acum?',
        inStock
          ? 'Da. În acest moment, produsul este afișat ca fiind în stoc.'
          : 'Nu. În acest moment, produsul este afișat ca indisponibil.',
        false,
        false
      );
    }

    const confidenceText = clean(document.querySelector('.zep-buy-confidence')?.innerText);
    const standardWarranty = confidenceText.match(/Garan(?:t|ț)ie\s+(\d+)\s+luni/i);
    if (standardWarranty) {
      add('Ce garanție standard are produsul?', `Produsul are garanție standard de ${standardWarranty[1]} luni.`, true, false);
    }

    if (document.querySelector('.zep-tax-note')) {
      add('Prețul afișat include TVA?', 'Da. Prețul afișat include TVA.', true, false);
    }

    const productSpecificCount = questions.filter((item) => item.productSpecific).length;
    if (questions.length < 2 || productSpecificCount < 1) return;
    installStyles();
    const section = create('section', 'zep-smart-faq');
    section.setAttribute('aria-labelledby', 'zep-smart-faq-title');
    const box = create('div', 'zep-smart-faq__box');
    const title = create('h2', 'zep-smart-faq__title', 'Întrebări frecvente despre acest produs');
    title.id = 'zep-smart-faq-title';
    const intro = create('p', 'zep-smart-faq__intro', 'Informații utile înainte de comandă, bazate pe fișa produsului.');
    box.append(title, intro);
    const visibleQuestions = questions.slice(0, 5);
    visibleQuestions.forEach((item) => {
      const details = create('details', 'zep-smart-faq__item');
      const summary = create('summary', '', item.question);
      const answer = create('p', 'zep-smart-faq__answer', item.answer);
      details.append(summary, answer);
      box.appendChild(details);
    });
    section.appendChild(box);
    const packageSection = document.querySelector('.zep-package-contents');
    const tabSection = description.closest('.tab_product');
    if (packageSection) packageSection.insertAdjacentElement('afterend', section);
    else if (tabSection) tabSection.insertAdjacentElement('afterend', section);
    else description.insertAdjacentElement('afterend', section);

    const schemaQuestions = visibleQuestions;
    if (schemaQuestions.length >= 2 && !document.getElementById('zep-smart-faq-schema')) {
      const schema = create('script');
      schema.id = 'zep-smart-faq-schema';
      schema.type = 'application/ld+json';
      schema.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: schemaQuestions.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer }
        }))
      });
      document.head.appendChild(schema);
    }
  };

  window.ZepPdpContentPipeline.register(() => {
    const description = document.querySelector('#tab_des');
    const productArea = document.querySelector('#product-single, .product-single, .main-product');
    if (!description || !productArea) return false;
    mount();
    return true;
  });
})();

(() => {
  if (window.__zepExpertVerdict) return;
  window.__zepExpertVerdict = true;

  const STYLE_ID = 'zep-expert-verdict-style';
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const normalize = (value) => clean(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  const shorten = (value) => clean(value);

  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const descriptionLines = (description) => {
    const elements = [...description.querySelectorAll('p, li, td, th')];
    const source = elements.length ? elements.map((element) => clean(element.innerText)) : clean(description.innerText).split(/\n+/);
    return source
      .filter((line) => line.length >= 18 && line.length <= 520)
      .filter((line, index, all) => all.findIndex((candidate) => normalize(candidate) === normalize(line)) === index);
  };

  const isGenericCompatibility = (value) => {
    const text = normalize(value);
    return /verificati modelele publicate|verifica modelul,? dimensiunile|specificatiile publicate permit|caracteristicile tehnice necesare|consultati (?:lista|fisa)/.test(text);
  };

  const findUse = (lines) => lines.find((line) => {
    const text = normalize(line);
    return !/nu este (?:potrivit|destinat|recomandat)/.test(text)
      && /\b(?:ideal(?:a)? pentru|potrivit(?:a)? pentru|destinat(?:a)? (?:pentru|utilizarii|inlocuirii)|conceput(?:a)? pentru|recomandat(?:a)? pentru|se foloseste pentru)\b/.test(text);
  });

  const findLevel = (lines) => {
    const matches = [
      ['semiprofesional', 'Semiprofesional'],
      ['profesional', 'Profesional'],
      ['hobby', 'Hobby'],
      ['uz gospodaresc', 'Uz gospodăresc'],
      ['utilizare gospodareasca', 'Utilizare gospodărească']
    ];
    for (const line of lines) {
      const text = normalize(line);
      const match = matches.find(([term]) => text.includes(term));
      if (match) return match[1];
    }
    return '';
  };

  const findCompatibility = (lines) => lines.find((line) => {
    const text = normalize(line);
    if (!/\b(?:compatibil|compatibilitate|cod oem)\b/.test(text) || isGenericCompatibility(line)) return false;
    return /\d/.test(text) || /\b(?:honda|ruris|stihl|husqvarna|elefant|micul padurar|briggs|loncin|china|universal)\b/.test(text);
  });

  const findCaution = (lines) => lines.find((line) => {
    const text = normalize(line);
    return /nu mai poate fi returnat|nu se poate returna|verificati (?:compatibilitatea|dimensiunile|codul)|verifica (?:compatibilitatea|dimensiunile|codul)|nu este compatibil|nu este recomandat/.test(text);
  });

  const topHighlight = (form) => {
    const item = form.querySelector('.zep-pdp-highlights__item');
    if (!item) return null;
    const label = clean(item.querySelector('dt')?.textContent);
    const value = clean(item.querySelector('dd')?.textContent);
    return label && value ? { label, value } : null;
  };

  const collectFacts = (form, description) => {
    const lines = descriptionLines(description);
    const facts = [];
    let hasDecisionFact = false;
    const add = (label, value, decision = false) => {
      const safeValue = shorten(value);
      if (!safeValue || facts.some((fact) => normalize(fact.value) === normalize(safeValue))) return;
      facts.push({ label, value: safeValue });
      if (decision) hasDecisionFact = true;
    };

    const use = findUse(lines);
    if (use) add('Potrivit pentru', use, true);

    const level = findLevel(lines);
    if (level) add('Nivel menționat în fișă', level, true);

    const compatibility = findCompatibility(lines);
    if (compatibility) add('Compatibilitate declarată', compatibility, true);

    const highlight = topHighlight(form);
    if (highlight) add(`Punct tehnic · ${highlight.label}`, highlight.value);

    const caution = findCaution(lines);
    if (caution) add('De verificat înainte de comandă', caution);

    return hasDecisionFact && facts.length >= 2 ? facts.slice(0, 4) : [];
  };

  const installStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = create('style');
    style.id = STYLE_ID;
    style.textContent = '.zep-expert-verdict{margin:10px 0;padding:12px;border:1px solid #d9e1ec;border-left:3px solid #10104b;border-radius:11px;background:#fafbfe}.zep-expert-verdict__header{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:8px}.zep-expert-verdict__title{margin:0;color:#10104b;font-size:15px;line-height:1.25;font-weight:900}.zep-expert-verdict__badge{flex:0 0 auto;padding:3px 7px;border-radius:999px;background:#edf0f8;color:#10104b;font-size:9px;line-height:1.2;font-weight:800}.zep-expert-verdict__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px;margin:0}.zep-expert-verdict__item{padding:9px;border-radius:8px;background:#fff;box-shadow:0 1px 0 rgba(16,16,75,.07)}.zep-expert-verdict__item:first-child{grid-column:1/-1}.zep-expert-verdict__item:nth-child(n+2),.zep-expert-verdict__source{display:none}.zep-expert-verdict dt{margin:0 0 3px;color:#6a7079;font-size:10px;line-height:1.25;font-weight:800;text-transform:uppercase;letter-spacing:.02em}.zep-expert-verdict dd{display:-webkit-box;overflow:hidden;margin:0;color:#252a31;font-size:12px;line-height:1.4;font-weight:650;-webkit-box-orient:vertical;-webkit-line-clamp:3}.zep-expert-verdict__toggle{margin:8px 0 0;padding:0;border:0;background:transparent;color:#10104b;font-size:11.5px;font-weight:800;text-decoration:underline;text-underline-offset:3px;cursor:pointer}.zep-expert-verdict.is-expanded .zep-expert-verdict__item:nth-child(n+2){display:block}.zep-expert-verdict.is-expanded .zep-expert-verdict__source{display:block;margin:8px 0 0;color:#737a83;font-size:10px;line-height:1.35}.zep-expert-verdict.is-expanded dd{display:block;overflow:visible;-webkit-line-clamp:unset}@media(max-width:520px){.zep-expert-verdict{padding:10px}.zep-expert-verdict__header{align-items:flex-start}.zep-expert-verdict__badge{font-size:8.5px}.zep-expert-verdict__grid{grid-template-columns:1fr}}';
    document.head.appendChild(style);
  };

  const render = () => {
    const description = document.querySelector('#tab_des');
    if (!description) return false;

    let rendered = false;

    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form, index) => {
      const highlights = form.querySelector('.zep-pdp-highlights');
      const confidence = form.querySelector('.zep-buy-confidence');
      const existing = form.querySelector('.zep-expert-verdict');
      if (existing) {
        if (highlights && highlights.nextElementSibling !== existing) highlights.insertAdjacentElement('afterend', existing);
        else if (!highlights && confidence && confidence.previousElementSibling !== existing) form.insertBefore(existing, confidence);
        rendered = true;
        return;
      }
      if (!highlights && !confidence) return;
      const facts = collectFacts(form, description);
      if (facts.length < 2) return;

      installStyles();
      const section = create('section', 'zep-expert-verdict');
      const titleId = `zep-expert-verdict-title-${index + 1}`;
      section.setAttribute('aria-labelledby', titleId);
      const header = create('div', 'zep-expert-verdict__header');
      const title = create('h2', 'zep-expert-verdict__title', 'Verdictul specialistului ZEP');
      title.id = titleId;
      const badge = create('span', 'zep-expert-verdict__badge', 'Bazat pe fișa produsului');
      header.append(title, badge);

      const list = create('dl', 'zep-expert-verdict__grid');
      facts.forEach((fact) => {
        const item = create('div', 'zep-expert-verdict__item');
        item.append(create('dt', '', fact.label), create('dd', '', fact.value));
        list.appendChild(item);
      });
      const source = create('p', 'zep-expert-verdict__source', 'Afișăm numai concluzii susținute de informațiile publicate pentru acest produs.');
      const toggle = create('button', 'zep-expert-verdict__toggle', 'Citește verdictul complet');
      toggle.type = 'button';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', () => {
        const expanded = section.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? 'Ascunde verdictul' : 'Citește verdictul complet';
      });
      section.append(header, list, toggle, source);

      if (highlights) highlights.insertAdjacentElement('afterend', section);
      else if (confidence) form.insertBefore(section, confidence);
      rendered = true;
    });

    
    return rendered;
  };

  window.ZepPdpContentPipeline.register(() => {
    const description = document.querySelector('#tab_des');
    const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    if (!description || !forms.length) return false;
    render();
    return true;
  });
})();

(() => {
  if (window.__zepRecentlyViewedFixed) return;
  window.__zepRecentlyViewedFixed = true;

  const claimNativeMarkup = () => {
    const nativeWrapper = document.querySelector('#js_recently_wrapper');
    const nativeSection = nativeWrapper?.closest('.js-recently-viewed');
    if (!nativeWrapper || !nativeSection) return;
    nativeWrapper.id = 'zep_recently_wrapper';
    nativeWrapper.classList.remove('grid-slider-ajax', 'js_carousel', 'laber-slick-carousel', 'recently-product');
    nativeSection.classList.replace('js-recently-viewed', 'zep-recently-viewed');
  };
  claimNativeMarkup();

  const STORAGE_KEYS = ['product-recently', 'product-recent'];
  const BLOCKED_HANDLES = new Set(['account', 'cart', 'collections', 'pages', 'search']);
  const validHandle = (value) => typeof value === 'string'
    && /^[a-z0-9][a-z0-9-]*$/.test(value)
    && !BLOCKED_HANDLES.has(value);

  const readHistory = () => STORAGE_KEYS.flatMap((key) => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  });

  const currentHandle = () => {
    const product = document.querySelector('#product-single');
    const data = product?.querySelector('.data-json-product');
    try {
      return data ? JSON.parse(data.textContent || '{}').handle || '' : product?.dataset.jsonProduct?.handle || '';
    } catch {
      return '';
    }
  };

  const saveHistory = (handles) => {
    STORAGE_KEYS.forEach((key) => {
      try {
        localStorage.setItem(key, JSON.stringify(handles));
      } catch {}
    });
  };

  const recordCurrent = () => {
    const current = currentHandle();
    if (!validHandle(current)) return '';
    const previous = readHistory().filter((handle, index, source) => validHandle(handle)
      && handle !== current
      && source.indexOf(handle) === index);
    saveHistory([current, ...previous].slice(0, 11));
    return current;
  };

  const fetchCard = async (handle) => {
    try {
      const response = await fetch(`${Shopify.routes.root}products/${encodeURIComponent(handle)}?view=pr_lazy_load`, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok || new URL(response.url).pathname.indexOf('/products/') !== 0) return '';
      const html = (await response.text()).trim();
      if (!html.includes('data-json-product') || !html.includes('product-collection')) return '';
      return `<div class="productLazyload product-item lazyloaded alo-item">${html}</div>`;
    } catch {
      return '';
    }
  };

  const setupCarousel = (wrapper, section, count) => {
    wrapper.setAttribute('tabindex', '0');
    wrapper.setAttribute('aria-label', 'Produse vizualizate recent');
    section.dataset.zepRecentCount = String(count);

    const title = section.querySelector('.wrap_title');
    if (!title) return;

    let controls = title.querySelector('.zep-recent-controls');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'zep-recent-controls';
      controls.innerHTML = '<button type="button" class="zep-recent-arrow" data-zep-recent-prev aria-label="Produsele anterioare">&#8249;</button><button type="button" class="zep-recent-arrow" data-zep-recent-next aria-label="Produsele urmatoare">&#8250;</button>';
      title.appendChild(controls);
    }

    const previous = controls.querySelector('[data-zep-recent-prev]');
    const next = controls.querySelector('[data-zep-recent-next]');
    const update = () => {
      const canScroll = wrapper.scrollWidth > wrapper.clientWidth + 2;
      controls.hidden = !canScroll;
      previous.disabled = wrapper.scrollLeft <= 2;
      next.disabled = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 2;
    };
    const move = (direction) => {
      const card = wrapper.querySelector('.product-item');
      const gap = Number.parseFloat(getComputedStyle(wrapper).columnGap || getComputedStyle(wrapper).gap || '12') || 12;
      const distance = card ? card.getBoundingClientRect().width + gap : wrapper.clientWidth * 0.8;
      wrapper.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    previous.onclick = () => move(-1);
    next.onclick = () => move(1);
    wrapper.addEventListener('scroll', update, { passive: true });
    requestAnimationFrame(update);
  };

  let running = false;
  const render = async () => {
    if (running) return;
    const wrapper = document.querySelector('#zep_recently_wrapper');
    const section = wrapper?.closest('.zep-recently-viewed');
    if (!wrapper || !section) return;

    running = true;
    section.style.display = 'none';
    wrapper.replaceChildren();
    wrapper.classList.remove('grid-slider', 'grid-init', 'slick-initialized', 'zep-recent-grid', 'zep-recent-track');

    const current = currentHandle();
    const handles = readHistory().filter((handle, index, source) => validHandle(handle)
      && handle !== current
      && source.indexOf(handle) === index).slice(0, 6);
    const stored = [current, ...handles].filter(validHandle).slice(0, 11);
    saveHistory(stored);

    if (!handles.length) {
      section.style.visibility = '';
      section.removeAttribute('aria-hidden');
      running = false;
      return;
    }

    const cards = (await Promise.all(handles.map(fetchCard))).filter(Boolean);
    if (!cards.length) {
      section.style.visibility = '';
      section.removeAttribute('aria-hidden');
      running = false;
      return;
    }

    wrapper.innerHTML = cards.join('');
    wrapper.classList.add('zep-recent-track', 'grid-init');
    setupCarousel(wrapper, section, cards.length);
    section.style.display = '';
    section.style.visibility = '';
    section.removeAttribute('aria-hidden');
    document.dispatchEvent(new CustomEvent('contentUpdated'));
    running = false;
  };

  let visibilityObserver = null;
  const deferRender = () => {
    const wrapper = document.querySelector('#zep_recently_wrapper');
    const section = wrapper?.closest('.zep-recently-viewed');
    if (!wrapper || !section || wrapper.dataset.zepRecentlyDeferred === 'true') return;
    wrapper.dataset.zepRecentlyDeferred = 'true';

    const begin = () => {
      visibilityObserver?.disconnect();
      visibilityObserver = null;
      render();
    };
    if (!('IntersectionObserver' in window)) {
      begin();
      return;
    }

    if (getComputedStyle(section).display === 'none') {
      section.style.display = '';
      section.style.visibility = 'hidden';
      section.setAttribute('aria-hidden', 'true');
    }

    visibilityObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) begin();
    }, { rootMargin: '300px 0px' });
    visibilityObserver.observe(section);
  };

  window.ZepPdpContentPipeline.register(() => {
    claimNativeMarkup();
    recordCurrent();
    const wrapper = document.querySelector('#zep_recently_wrapper');
    const section = wrapper?.closest('.zep-recently-viewed');
    if (!wrapper || !section) return false;
    deferRender();
    return true;
  });
})();


/* ZEP PDP: transparent tax label (shop.taxesIncluded verified 2026-09-14) */
(() => {
  if (window.__zepTaxLabelReady) return;
  window.__zepTaxLabelReady = true;

  const renderTaxLabel = () => {
    document.querySelectorAll('.product-price').forEach((box) => {
      if (box.querySelector('.zep-tax-note')) return;
      const price = box.querySelector('[data-js-product-price], .price, #js-product-price');
      if (!price) return;

      const note = document.createElement('span');
      note.className = 'zep-tax-note';
      note.textContent = 'TVA inclus';
      note.setAttribute('aria-label', 'Pretul include TVA');
      price.insertAdjacentElement('afterend', note);
    });
  };

  if (!document.getElementById('zep-tax-note-style')) {
    const style = document.createElement('style');
    style.id = 'zep-tax-note-style';
    style.textContent = '.product-price .zep-tax-note{display:inline-block;margin-left:8px;color:#667085;font-size:12px;font-weight:500;line-height:1.3;vertical-align:baseline}@media(max-width:576px){.product-price .zep-tax-note{font-size:11.5px;margin-left:6px}}';
    document.head.appendChild(style);
  }

  window.ZepPdpLivePipeline.register(renderTaxLabel);
})();


/* ZEP PDP: suppress economically invalid extended-warranty offers */
(() => {
  if (window.__zepWarrantyValueGuard) return;
  window.__zepWarrantyValueGuard = true;

  const money = (value) => {
    const normalized = String(value || '')
      .replace(/\s/g, '')
      .replace(/\.(?=\d{3}(?:\D|$))/g, '')
      .replace(',', '.')
      .replace(/[^\d.\-]/g, '');
    const amount = Number.parseFloat(normalized);
    return Number.isFinite(amount) ? amount : 0;
  };
  const plain = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  const applyWarrantyGuard = () => {
    const productPrice = money(document.querySelector('#js-product-price, [data-js-product-price]')?.textContent);
    if (!(productPrice > 0)) return;

    document.querySelectorAll('.po-productPageOptions-root').forEach((root) => {
      const optionRows = [...root.querySelectorAll('.po-radioButtons-radioItem')];
      optionRows.forEach((row) => {
        const label = row.querySelector('.po-optionItemLabel-label, .po-optionItemLabel-optionItem');
        if (!label || !plain(label.textContent).includes('garantie extinsa')) return;
        const fee = money(row.querySelector('.po-optionItemLabel-price')?.textContent);
        const invalid = fee > 0 && fee >= productPrice;
        row.hidden = invalid;
        row.classList.toggle('zep-warranty-hidden', invalid);
        if (invalid) row.setAttribute('aria-hidden', 'true');
        else row.removeAttribute('aria-hidden');
      });

      if (optionRows.length) {
        const hasVisibleOption = optionRows.some((row) => !row.hidden);
        root.hidden = !hasVisibleOption;
      }
    });
  };

  window.ZepPdpLivePipeline.register(applyWarrantyGuard);
})();
(()=>{if(window.__zepStickyBuybarGuard)return;window.__zepStickyBuybarGuard=!0;const i=()=>document.querySelector('.details-info form[data-type="add-to-cart-form"], #product-single form[action*="/cart/add"]'),o=()=>document.querySelector(".js_sticky_atc_wrapper"),u=t=>!!(t&&!t.hidden&&t.getClientRects().length&&getComputedStyle(t).visibility!=="hidden"),m=t=>t?.querySelector('.js_add_to_cart_button:not(.sticky_atc_js), [name="add"]'),d=t=>{const e=m(t),a=t?.querySelector(".js-btn-sold-out"),n=t?.querySelector("#js-pr-unavailable");return!e||e.disabled||e.classList.contains("d-none-important")||u(a)||u(n)},y=t=>{const e=Math.max(1,Number.parseInt(t?.dataset.min||t?.min||"1",10)||1),a=Number.parseInt(t?.dataset.max||t?.max||"9999",10),n=Number.isFinite(a)&&a>=e?a:9999,r=Math.min(n,Math.max(e,Number.parseInt(t?.value||"1",10)||e));return t&&(t.value=String(r)),r},c=(t,e)=>{!t||!e||(e.value=String(y(t)),e.dispatchEvent(new Event("input",{bubbles:!0})))},s=()=>{const t=i(),e=o();if(!e)return;const a=e.querySelector(".sticky_atc_js, [data-js-product-button-add-to-cart]"),n=d(t);e.hidden=n,e.setAttribute("aria-hidden",n?"true":"false"),a&&(a.disabled=n,a.setAttribute("aria-disabled",n?"true":"false"),a.setAttribute("aria-label",n?"Produs indisponibil":"Adaug\u0103 produsul \xEEn co\u0219"))};document.addEventListener("change",t=>{const e=i(),a=o();if(!e||!a)return;const n=e.querySelector('input[name="quantity"]'),r=a.querySelector(".js_sticky_qty");t.target===n&&c(n,r),t.target===r&&c(r,n),window.ZepPdpLivePipeline.schedule()}),document.addEventListener("click",t=>{if(t.target.closest('form[data-type="add-to-cart-form"] .js_plus, form[data-type="add-to-cart-form"] .js_minus')){requestAnimationFrame(()=>{const e=i()?.querySelector('input[name="quantity"]'),a=o()?.querySelector(".js_sticky_qty");c(e,a)});return}if(!t.target.closest(".js_sticky_atc_wrapper .sticky_atc_js"))return;const a=i();if(d(a)){t.preventDefault(),t.stopImmediatePropagation(),s();return}const n=a.querySelector('input[name="quantity"]'),r=o()?.querySelector(".js_sticky_qty");c(r,n)},!0);window.ZepPdpLivePipeline.register(s)})();
(()=>{if(window.__zepSmartCompare)return;window.__zepSmartCompare=!0;const g=3,b=".js-store-lists-add-compare",q=".popup-compare-full__content",k=()=>{const t=document.querySelector(b);return{limit:t?.dataset.zepCompareLimit||"",bestPrice:t?.dataset.zepCompareBestPrice||"",guide:t?.dataset.zepCompareGuide||"",table:t?.dataset.zepCompareTableLabel||"",technicalTitle:t?.dataset.zepCompareTechnicalTitle||"",specification:t?.dataset.zepCompareSpecification||"",missing:t?.dataset.zepCompareMissing||"",mismatch:t?.dataset.zepCompareMismatch||"",morePowerful:t?.dataset.zepCompareMorePowerful||"",lighter:t?.dataset.zepCompareLighter||"",hiddenRows:(t?.dataset.zepCompareHiddenRows||"").split("|||").map(u).filter(Boolean)}},D=()=>{const t=window.theme?.StoreLists?.lists?.compare?.current_storage;if(t)return t;for(let e=0;e<localStorage.length;e+=1){const r=localStorage.key(e);if(r==="compare-guest"||r?.startsWith("compare-customer-"))return r}return"compare-guest"},K=()=>{try{const t=JSON.parse(localStorage.getItem(D())||"[]");return Array.isArray(t)?t:[]}catch{return[]}},z=t=>{if(!t)return;let e=document.getElementById("zep-compare-status");e||(e=document.createElement("div"),e.id="zep-compare-status",e.className="zep-compare-status",e.setAttribute("role","status"),e.setAttribute("aria-live","polite"),document.body.appendChild(e)),e.textContent=t,e.classList.add("is-visible"),clearTimeout(z.timer),z.timer=setTimeout(()=>e.classList.remove("is-visible"),3200)},H=t=>{const e=(t||"").replace(/\s/g,"").replace(/[^\d,.-]/g,"").replace(/\.(?=\d{3}(?:\D|$))/g,"").replace(",","."),r=Number.parseFloat(e);return Number.isFinite(r)?r:null},C=(t=document)=>{t.querySelectorAll?.(b).forEach(e=>{const r=e.getAttribute("data-button-status")==="added";e.setAttribute("aria-pressed",r?"true":"false");const a=e.querySelector(r?".added":".text")?.textContent?.trim();a&&e.setAttribute("aria-label",a)})},I=t=>{t.querySelectorAll(".js-store-lists-remove-compare, .js-store-lists-clear-compare").forEach(e=>{e.dataset.zepKeyboardReady||(e.dataset.zepKeyboardReady="true",e.setAttribute("role","button"),e.setAttribute("tabindex","0"),e.addEventListener("keydown",r=>{r.key!=="Enter"&&r.key!==" "||(r.preventDefault(),e.click())}))})},u=t=>(t||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLocaleLowerCase("ro-RO").replace(/[^a-z0-9]+/g," ").trim(),A=[["power",["putere motor","putere nominala","putere maxima","putere","motor power"]],["weight",["greutate neta","greutate","masa neta","weight"]],["displacement",["capacitate cilindrica","cilindree","cylinder capacity"]],["blade_length",["lungime lama","lungime sina","lungime ghidaj"]],["chain_pitch",["pas lant","pasul lantului"]],["power_source",["tip alimentare","alimentare","combustibil"]],["voltage",["tensiune nominala","tensiune","voltaj"]],["pressure",["presiune maxima","presiune de lucru","presiune"]],["flow",["debit maxim","debit aer","debit apa","debit"]],["tank",["capacitate rezervor","volum rezervor"]],["autonomy",["autonomie"]],["suction_depth",["adancime aspiratie","adancime maxima de aspiratie"]],["head",["inaltime refulare","inaltime pompare","inaltime maxima"]],["connection",["diametru racord","diametru conectare"]],["working_width",["latime de lucru","latime taiere","latime cosire"]],["cutting_diameter",["diametru taiere","diametru de taiere"]],["rpm",["turatie maxima","turatie","viteza de rotatie"]],["battery",["capacitate acumulator","acumulator","baterie"]],["engine_type",["tip motor","motor"]],["starting",["sistem pornire","tip pornire","pornire"]],["frequency",["frecventa"]],["dimensions",["dimensiuni produs","dimensiuni"]]],L=[["chainsaw",["drujba","fierastrau cu lant"],["power_source","power","displacement","blade_length","chain_pitch","weight"]],["trimmer",["motocoasa","trimmer","coasa"],["power_source","power","displacement","cutting_diameter","engine_type","weight"]],["generator",["generator"],["power","voltage","frequency","tank","autonomy","weight"]],["pump",["motopompa","pompa","hidrofor"],["power","flow","head","suction_depth","connection","weight"]],["compressor",["compresor"],["power","pressure","flow","tank","voltage","weight"]],["tiller",["motocultor","motosapa"],["power","displacement","working_width","engine_type","starting","weight"]],["mower",["masina de tuns gazon","masina tuns gazon"],["power_source","power","working_width","battery","weight"]]],$=t=>{const e=u(t);return A.find(([,r])=>r.some(a=>e===a||e.includes(a)))?.[0]||null},w=(t,e,r)=>{const a=(e||"").replace(/\s+/g," ").replace(/:$/,"").trim(),i=(r||"").replace(/\s+/g," ").replace(/^:/,"").trim(),o=$(a);!o||!i||i.length>140||t.has(o)||t.set(o,{label:a,value:i})},J=t=>{const e=new DOMParser().parseFromString(t||"","text/html"),r=new Map;return e.querySelectorAll("tr").forEach(a=>{const i=[...a.querySelectorAll(":scope > th, :scope > td")];i.length>1&&w(r,i[0].textContent,i.slice(1).map(o=>o.textContent).join(" "))}),e.querySelectorAll("dt").forEach(a=>w(r,a.textContent,a.nextElementSibling?.matches("dd")?a.nextElementSibling.textContent:"")),e.querySelectorAll("li, p").forEach(a=>{const i=a.textContent.replace(/\s+/g," ").trim(),o=i.match(/^([^:]{2,55}):\s*(.{1,140})$/);o&&w(r,o[1],o[2]);const l=a.querySelector(":scope > strong:first-child, :scope > b:first-child");l&&w(r,l.textContent,i.slice(l.textContent.length))}),r},S=new Map,N=t=>{const e=u([t.title,t.type,...t.collections||[]].join(" ")),r=L.find(([,a])=>a.some(i=>e.includes(i)))?.[0]||"";return{...t,family:r,specs:J(t.description)}},V=t=>{if(S.has(t))return S.get(t);const e=window.Shopify?.routes?.root||"/",r=fetch(`${e}products/${encodeURIComponent(t)}.js`,{credentials:"same-origin",headers:{"X-Requested-With":"XMLHttpRequest"}}).then(a=>{if(!a.ok)throw new Error("Product unavailable");return a.json()}).then(a=>N({title:a.title||"",type:a.type||"",description:a.description||a.body_html||"",collections:[]})).catch(()=>null);return S.set(t,r),r},W=t=>[...t.querySelectorAll(".zep-compare-source")].map(e=>{try{const r=JSON.parse(e.textContent);return N(r)}catch{return null}}).filter(Boolean).slice(0,g),X=async t=>{const e=W(t);if(e.length)return e;const r=[...t.querySelectorAll(".product-compare[data-product-handle]")].map(a=>a.dataset.productHandle).filter(Boolean).slice(0,g);return(await Promise.all(r.map(V))).filter(Boolean)},G=(t,e)=>{const a=(t||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLocaleLowerCase("ro-RO").replace(/\s+/g," ").match(/(-?\d+(?:[.,]\d+)?)\s*(kw|w|cp|hp|kg|g)(?:\s|$)/);if(!a)return null;let i=Number.parseFloat(a[1].replace(",",".")),o=a[2];return!Number.isFinite(i)||(e==="power"&&o==="w"&&(i/=1e3,o="kw"),e==="weight"&&o==="g"&&(i/=1e3,o="kg"),e==="power"&&!["kw","cp","hp"].includes(o))||e==="weight"&&o!=="kg"?null:{amount:i,unit:o}},U=(t,e)=>{if(!t||!e)return;const r=document.createElement("small");r.className="zep-compare-value-badge",r.textContent=e,t.appendChild(r)},Q=async(t,e)=>{const r=[...t.querySelectorAll(".zep-compare-source, .product-compare[data-product-handle]")].map(n=>n.dataset.productHandle||n.textContent.length).slice(0,g).join("|");if(!r||t.dataset.zepTechnicalSignature===r)return;t.dataset.zepTechnicalSignature=r,t.querySelector(".zep-technical-compare")?.remove(),t.querySelector(".zep-compare-category-warning")?.remove();const a=await X(t);if(a.length<2)return;const i=[...new Set(a.map(n=>n.family).filter(Boolean))],o=[...new Set(a.map(n=>u(n.type)).filter(Boolean))],l=i.length===1&&a.every(n=>n.family===i[0]),p=o.length===1&&a.every(n=>u(n.type)===o[0]);if(!l&&!p){if(e.mismatch){const n=document.createElement("p");n.className="zep-compare-category-warning",n.setAttribute("role","alert"),n.textContent=e.mismatch,t.querySelector(".zep-compare-guide")?.after(n)}return}const B=(L.find(([n])=>n===i[0])?.[2]||A.map(([n])=>n)).filter(n=>a.some(m=>m.specs.has(n))).slice(0,7);if(!B.length||!e.technicalTitle)return;const f=document.createElement("section");f.className="zep-technical-compare";const M=document.createElement("h3");M.textContent=e.technicalTitle,f.appendChild(M);const v=document.createElement("div");v.className="zep-technical-compare__scroll";const x=document.createElement("table");x.setAttribute("aria-label",e.technicalTitle);const R=document.createElement("thead"),j=document.createElement("tr");[e.specification,...a.map(n=>n.title)].forEach(n=>{const m=document.createElement("th");m.scope="col",m.textContent=n,j.appendChild(m)}),R.appendChild(j),x.appendChild(R);const P=document.createElement("tbody");B.forEach(n=>{const m=document.createElement("tr"),E=document.createElement("th");E.scope="row",E.textContent=a.find(s=>s.specs.get(n))?.specs.get(n).label||n,m.appendChild(E);const Z=a.map(s=>{const h=document.createElement("td");return h.textContent=s.specs.get(n)?.value||e.missing,m.appendChild(h),h}),F=a.map(s=>s.specs.get(n)?.value?G(s.specs.get(n).value,n):null),y=F.filter(Boolean);if(y.length>1&&new Set(y.map(s=>s.unit)).size===1){const s=F.map(d=>d?.amount??null),h=n==="weight"?Math.min(...y.map(d=>d.amount)):Math.max(...y.map(d=>d.amount));s.filter(d=>d===h).length===1&&U(Z[s.indexOf(h)],n==="weight"?e.lighter:e.morePowerful)}P.appendChild(m)}),x.appendChild(P),v.appendChild(x),f.appendChild(v);const O=t.querySelector(".zep-compare-guide");O?O.after(f):t.prepend(f)},_=t=>{const e=t.matches?.(q)?t:t.querySelector?.(q);if(!e||!e.children.length)return;const r=k(),a=e.querySelector("table");if(a&&r.table&&a.setAttribute("aria-label",r.table),r.guide&&!e.querySelector(".zep-compare-guide")){const o=document.createElement("p");o.className="zep-compare-guide",o.textContent=r.guide,e.prepend(o)}Q(e,r).catch(()=>{delete e.dataset.zepTechnicalSignature}),e.querySelectorAll("tr").forEach(o=>{const l=u(o.querySelector(".compare__title h3")?.textContent);o.classList.toggle("zep-compare-weak-row",r.hiddenRows.includes(l))}),e.querySelectorAll("tr").forEach((o,l)=>{if(l===0)return;const p=[...o.querySelectorAll(".compare__item p")].map(c=>c.textContent.replace(/\s+/g," ").trim().toLocaleLowerCase("ro-RO")).filter(c=>c&&c!=="-");o.classList.toggle("zep-compare-row--different",new Set(p).size>1)}),e.querySelectorAll(".zep-compare-best-price").forEach(o=>o.remove());const i=[...e.querySelectorAll(".product-compare")].map(o=>{const l=o.dataset.productHandle,p=l?[...e.querySelectorAll("[data-js-store-lists-product-compare]")].find(c=>c.dataset.productHandle===l&&c.querySelector(".in-stock, .out-stock")):null;return{card:o,available:!p||!!p.querySelector(".in-stock"),value:H(o.querySelector(".product-compare__price .current, .product-compare__price .price")?.textContent)}}).filter(o=>o.available).filter(o=>o.value!==null);if(i.length>1&&r.bestPrice){const o=Math.min(...i.map(c=>c.value)),p=i.find(c=>c.value===o)?.card?.querySelector(".product-compare__content");if(p){const c=document.createElement("span");c.className="zep-compare-best-price",c.textContent=r.bestPrice,p.prepend(c)}}I(e)},Y=()=>{if(document.getElementById("zep-smart-compare-style"))return;const t=document.createElement("style");t.id="zep-smart-compare-style",t.textContent=".zep-compare-status{position:fixed;left:50%;bottom:24px;z-index:100000;max-width:min(420px,calc(100vw - 32px));padding:12px 16px;border-radius:10px;background:#17191c;color:#fff;font-size:14px;font-weight:700;line-height:1.35;box-shadow:0 10px 30px rgba(0,0,0,.22);opacity:0;pointer-events:none;transform:translate(-50%,12px);transition:opacity .2s,transform .2s}.zep-compare-status.is-visible{opacity:1;transform:translate(-50%,0)}.zep-compare-guide,.zep-compare-category-warning{margin:0 0 14px;padding:10px 12px;border:1px solid #dfe7ff;border-radius:9px;background:#f5f8ff;color:#26324a;font-size:13px;line-height:1.4}.zep-compare-category-warning{border-color:#f0df9f;background:#fffaf0;color:#6b5411}.zep-compare-best-price,.zep-compare-value-badge{display:inline-flex;margin:0 0 8px;padding:4px 8px;border-radius:999px;background:#eaf7ed;color:#14752c;font-size:11px;font-weight:800;line-height:1}.zep-compare-value-badge{display:flex;width:max-content;margin:5px 0 0}.zep-technical-compare{margin:0 0 18px}.zep-technical-compare h3{margin:0 0 10px;font-size:18px}.zep-technical-compare__scroll{overflow-x:auto;-webkit-overflow-scrolling:touch}.zep-technical-compare table{width:100%;min-width:680px;border-collapse:separate;border-spacing:0;border:1px solid #e5e7eb;border-radius:10px;overflow:hidden}.zep-technical-compare th,.zep-technical-compare td{padding:10px 12px;border-right:1px solid #e5e7eb;border-bottom:1px solid #e5e7eb;text-align:left;vertical-align:top;font-size:13px}.zep-technical-compare th{font-weight:800;background:#f8faf9}.zep-technical-compare tr:last-child>*{border-bottom:0}.zep-technical-compare tr>*:last-child{border-right:0}.zep-compare-weak-row{display:none}.compare_content{overflow-x:auto;-webkit-overflow-scrolling:touch}.compare_content table{min-width:720px}.compare_content tr.zep-compare-row--different{background:#fffaf0}.compare_content tr.zep-compare-row--different>.compare__title{box-shadow:inset 3px 0 #f2b400}@media(max-width:767px){.zep-compare-status{bottom:78px}.zep-technical-compare__scroll{margin-inline:-12px;padding-inline:12px}.zep-technical-compare th:first-child{position:sticky;left:0;z-index:2}.compare_content{margin-inline:-12px;padding-inline:12px}.compare_content .compare__title{position:sticky;left:0;z-index:2;background:#fff}.compare_content tr.zep-compare-row--different>.compare__title{background:#fffaf0}}",document.head.appendChild(t)};let ee=!1;const rr=()=>{ee||(ee=!0,requestAnimationFrame(()=>{ee=!1,C(document),_(document)}))};document.addEventListener("click",t=>{const e=t.target.closest(b);if(!e)return;if(!(e.getAttribute("data-button-status")==="added")&&K().length>=g){t.preventDefault(),t.stopImmediatePropagation(),z(e.dataset.zepCompareLimit||k().limit);return}rr()},!0);const T=()=>{Y(),C(document),_(document),new MutationObserver(rr).observe(document.body,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["data-button-status"]})};document.readyState==="loading"?document.addEventListener("DOMContentLoaded",T,{once:!0}):T()})();



(() => {
  if (window.__zepRestockRequestV1) return;
  window.__zepRestockRequestV1 = true;

  const styleId = 'zep-restock-request-style';
  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };
  const addHidden = (form, name, value) => {
    const input = create('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };
  const ensureStyle = () => {
    if (document.getElementById(styleId)) return;
    const style = create('style');
    style.id = styleId;
    style.textContent = '.zep-restock-request{margin:12px 0 0;padding:12px;border:1px solid #d9def5;border-radius:10px;background:#f5f6ff}.zep-restock-request__title{display:block;margin:0 0 7px;font-size:13px;line-height:1.35;font-weight:800;color:#17191c}.zep-restock-request__row{display:flex;gap:8px}.zep-restock-request__email{min-width:0;flex:1;min-height:48px;padding:10px 12px;border:1px solid #aeb6c2;border-radius:8px;background:#fff;color:#17191c;font-size:14px}.zep-restock-request__email:focus{outline:3px solid rgba(16,16,75,.2);outline-offset:1px;border-color:#10104b}.zep-restock-request__button{min-height:48px;padding:10px 15px;border:0;border-radius:8px;background:#10104b;color:#fff;font-size:13px;font-weight:800;cursor:pointer}.zep-restock-request__button:hover{background:#202066}.zep-restock-request__privacy{margin:7px 0 0;font-size:11px;line-height:1.4;color:#626872}.zep-restock-request__success{margin:0;padding:11px;border-radius:8px;background:#eaf6ee;color:#176b32;font-size:13px;line-height:1.45;font-weight:750}@media(max-width:600px){.zep-restock-request__row{flex-direction:column}.zep-restock-request__button{width:100%}}';
    document.head.appendChild(style);
  };
  const mount = (card, index) => {
    if (card.querySelector('.zep-restock-request')) return;
    const productForm = card.closest('form[data-type="add-to-cart-form"]');
    if (!productForm) return;

    ensureStyle();
    const productId = document.querySelector('[data-product-id]')?.dataset.productId || String(index);
    const title = document.querySelector('h1')?.textContent?.replace(/\s+/g, ' ').trim() || document.title;
    const variantId = new URLSearchParams(location.search).get('variant') || '';
    const formId = `zep-restock-form-${productId}`;
    let requestForm = document.getElementById(formId);

    if (!requestForm) {
      requestForm = create('form');
      requestForm.id = formId;
      requestForm.method = 'post';
      requestForm.action = `/contact#${formId}`;
      requestForm.acceptCharset = 'UTF-8';
      requestForm.hidden = true;
      addHidden(requestForm, 'form_type', 'contact');
      addHidden(requestForm, 'utf8', '✓');
      addHidden(requestForm, 'contact[Subiect]', 'Cerere notificare revenire in stoc');
      addHidden(requestForm, 'contact[Produs]', title);
      addHidden(requestForm, 'contact[ID produs]', productId);
      addHidden(requestForm, 'contact[ID varianta]', variantId);
      addHidden(requestForm, 'contact[URL produs]', location.href);
      addHidden(requestForm, 'contact[Mesaj]', 'Doresc sa fiu notificat prin email cand acest produs revine in stoc.');
      const returnUrl = `${location.pathname}${location.search}${location.search ? '&' : '?'}zep_restock_sent=1#${formId}`;
      addHidden(requestForm, 'return_to', returnUrl);
      productForm.insertAdjacentElement('afterend', requestForm);
    }

    const panel = create('div', 'zep-restock-request');
    const sent = new URLSearchParams(location.search).get('zep_restock_sent') === '1' && location.hash === `#${formId}`;
    if (sent) {
      panel.appendChild(create('p', 'zep-restock-request__success', 'Cererea a fost inregistrata. Iti trimitem un email cand produsul revine in stoc.'));
    } else {
      const label = create('label', 'zep-restock-request__title', 'Vrei sa te anuntam cand revine in stoc?');
      const emailId = `${formId}-email`;
      label.htmlFor = emailId;
      const row = create('div', 'zep-restock-request__row');
      const email = create('input', 'zep-restock-request__email');
      email.id = emailId;
      email.type = 'email';
      email.name = 'contact[email]';
      email.placeholder = 'Adresa ta de email';
      email.autocomplete = 'email';
      email.inputMode = 'email';
      email.required = true;
      email.setAttribute('form', formId);
      email.setAttribute('aria-label', 'Adresa de email pentru notificarea de stoc');
      const button = create('button', 'zep-restock-request__button', 'Anunta-ma cand revine');
      button.type = 'submit';
      button.setAttribute('form', formId);
      row.append(email, button);
      const privacy = create('p', 'zep-restock-request__privacy', 'Folosim adresa doar pentru aceasta alerta. Nu te abonam la newsletter.');
      panel.append(label, row, privacy);
    }

    const actions = card.querySelector('.zep-soldout-rescue__actions');
    actions ? actions.insertAdjacentElement('beforebegin', panel) : card.appendChild(panel);
  };
  const run = () => {
    document.querySelectorAll('.zep-soldout-rescue').forEach(mount);
  };

  window.ZepPdpLivePipeline?.register(() => {
    run();
    return true;
  });
  document.addEventListener('contentUpdated', run);
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  run();
})();
